// 0. JAVASCRIPT LAYER [ 0.00 PRELOAD SCRIPTS ] #######################################################################

// 0.1. PRELOADER -----------------------------------------

jQuery('html').addClass('preloader');

// 0.1. END -----------------------------------------------

// 0.2 LOAD FUNCTIONS -------------------------------------

// 0.2. END -----------------------------------------------

/*
 * JavaScript Templates Runtime
 * https://github.com/blueimp/JavaScript-Templates
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/MIT
 */

/* global define */

;(function ($) {
    'use strict'
    var tmpl = function (id, data) {
        var f = tmpl.cache[id]
        return data ? f(data, tmpl) : function (data) {
            return f(data, tmpl)
        }
    }
    tmpl.cache = {}
    tmpl.encReg = /[<>&"'\x00]/g // eslint-disable-line no-control-regex
    tmpl.encMap = {
        '<': '&lt;',
        '>': '&gt;',
        '&': '&amp;',
        '"': '&quot;',
        "'": '&#39;'
    }
    tmpl.encode = function (s) {
        return (s == null ? '' : '' + s).replace(
            tmpl.encReg,
            function (c) {
                return tmpl.encMap[c] || ''
            }
        )
    }
    if (typeof define === 'function' && define.amd) {
        define(function () {
            return tmpl
        })
    } else if (typeof module === 'object' && module.exports) {
        module.exports = tmpl
    } else {
        $.tmpl = tmpl
    }
}(this))
// 0. JAVASCRIPT LAYER [ 0.02 DEVICE CHECK ] ##########################################################################
    
// 0.1. DEVICE CHECK --------------------------------------------------------------------------------------------------

function initDeviceCheck() {

  var deviceAgent = navigator.userAgent.toLowerCase();

  jQuery('html').addClass('desktop');

  if (deviceAgent.match(/(iphone|ipod|ipad)/)) {
    jQuery('html').removeClass('desktop');
    jQuery('html').addClass('ios');
    jQuery('html').addClass('mobile');
  }

  if (deviceAgent.match(/android/)) {
    jQuery('html').removeClass('desktop');
    jQuery('html').addClass('android');
    jQuery('html').addClass('mobile');
  }

  if (deviceAgent.match(/blackberry/)) {
    jQuery('html').removeClass('desktop');
    jQuery('html').addClass('blackberry');
    jQuery('html').addClass('mobile');
  }

  if (deviceAgent.match(/(symbianos|^sonyericsson|^nokia|^samsung|^lg)/)) {
    jQuery('html').removeClass('desktop');
    jQuery('html').addClass('mobile');
  }

}

// 0.1. END -----------------------------------------------------------------------------------------------------------
  
// 0.0 END ############################################################################################################


// 0.2 LOAD FUNCTIONS -------------------------------------

initDeviceCheck();

// 0.2. END -----------------------------------------------

// 0. JAVASCRIPT LAYER [ 0.00 PRELOAD SCRIPTS END ] ###################################################################
// JAVASCRIPT LAYER [APP.JS]  =========================================================================================

jQuery(document).ready(function($) {

  // PRELOADER --------------------------------------------

  $('html').removeClass('preloader');
  $('html').addClass('weee-app');

  // LOAD FUNCTIONS ---------------------------------------

// JAVASCRIPT LAYER [APP.JS]  =========================================================================================

// ====== INDEX  ======================================================================================================
// ==
// == A. BURGER MENU
// == B. HOMEPAGE CAROUSEL
// ==
// ====== INDEX  ======================================================================================================

// A. SHOW/HIDE +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

// A.1. BURGER MENU ---------------------------------------------------------------------------------------------------

function debounce(func, wait, immediate) {
	var timeout;
	return function () {
		var context = this,
			args = arguments;
		var later = function () {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
}

$(".reveal").click(function (e) {
	var target = $(this).attr("href");

	if ($(target).hasClass("hidden")) {
		$(target).removeClass("hidden");
		$(".reveal").addClass("close");
	} else {
		$(target).addClass("hidden");
		$(".reveal").removeClass("close");
	}
	e.preventDefault();
});

// A.1. END -----------------------------------------------------------------------------------------------------------

// A.2. GENERAL SHOW --------------------------------------------------------------------------------------------------

$(".showhide").click(function (e) {
	var target = $(this).attr("href");

	if ($(target).hasClass("hidden")) {
		$(target).removeClass("hidden");
		$(".showhide").addClass("close");
	} else {
		$(target).addClass("hidden");
		$(".showhide").removeClass("close");
	}

	e.preventDefault();
});

// A.2. END -----------------------------------------------------------------------------------------------------------

// A.2.3. MOBILE SHOWHIDE -----------------------------

(function ($) {
	if ($("html").hasClass("mobile")) {
		$(".a-config").on("click", function () {
			//e.preventDefault();
			if ($(".a-config").hasClass("active")) {
				$(".a-config").removeClass("active");
				$("body").removeClass("fixed");
			} else {
				$(".a-config").addClass("active");
				$("body").addClass("fixed");
			}
		});
	}
})(jQuery);

// A.2.3. END -----------------------------------------

// A.2. END -----------------------------------------------------------------------------------------------------------

// A.3. SCROLL TO LINK ------------------------------------------------------------------------------------------------

$(".textLink, .bob-backUp").click(function (event) {
	event.preventDefault();

	//calculate destination place
	var dest = 0;
	if ($(this.hash).offset().top > $(document).height() - $(window).height()) {
		dest = $(document).height() - $(window).height();
	} else {
		dest = $(this.hash).offset().top;
	}

	//go to destination
	$("html,body").animate({ scrollTop: dest }, 1000, "swing");

	//add class to burger
	$("#mobi-nav").addClass("hide-nav");
});

$(".scroll-to").on("click", function (e) {
	e.preventDefault();
	var link = $(this),
		section_id = link.attr("href");

	$("html, body")
		.stop()
		.animate(
			{
				scrollTop: $(section_id).offset().top - 100,
			},
			500
		);
});

//smooth scrolling from css-tricks
// $('a[href*="#"]:not([href="#"])').click(function () {
//   if (
//     location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") &&
//     location.hostname == this.hostname
//   ) {
//     var target = $(this.hash);
//     target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
//     if (target.length) {
//       $("html, body").animate(
//         {
//           scrollTop: target.offset().top - 100,
//         },
//         1000
//       );
//       return false;
//     }
//   }
// });

// A.3. END -----------------------------------------------------------------------------------------------------------

// A.4. STICKY DIVS ---------------------------------------------------------------------------------------------------

var htmlt = $("html").offset().top;

$(document).scroll(function () {
	// Hide the logo, and show as you scroll
	var body = $("body");
	if ($(this).scrollTop() > htmlt) {
		if (!body.hasClass("sticky")) {
			body.addClass("sticky");
		}
	} else {
		if (body.hasClass("sticky")) {
			body.removeClass("sticky");
		}
	}
});

// A.4. END -----------------------------------------------------------------------------------------------------------

// A.5. SCREEN SIZE CHECK ---------------------------------------------------------------------------------------------

var screen = $(window).width();

// A.5. END -----------------------------------------------------------------------------------------------------------

// A.6. RESOURCE PATHS ------------------------------------------------------------------------------------------------

var icons = "assets/includes/icons/";

// A.6. END -----------------------------------------------------------------------------------------------------------

// A.7. GOOGLE AUTO COMPLETE ------------------------------------------------------------------------------------------
$(".sidebar_places_autocomplete").each(function () {
	google.maps.event.addDomListener(
		window,
		"load",
		global_google_places_initialize($(this).attr("id"))
	);
});
function global_google_places_initialize(element_id) {
	var input = document.getElementById(element_id);
	var autocomplete = new google.maps.places.Autocomplete(input, {
		componentRestrictions: { country: ["GB", "IM", "GG", "JE"] },
	});
	autocomplete.addListener("place_changed", function () {
		var place = autocomplete.getPlace();
		localStorage.setItem("google_result", JSON.stringify(place));
	});
}
// A.7. END -----------------------------------------------------------------------------------------------------------

// A.8. Filter System -----------------------------------------------------------------------------------------
function newsListingInit() {
	const tabsList = document.querySelectorAll(".filter-button-group");
	const panels = document.querySelectorAll('[id^="news_listing"]');

	// The tab switching function
	const switchTab = (oldTab, newTab, e) => {
		newTab.focus();
		// Make the active tab focusable by the user (Tab key)
		newTab.removeAttribute("tabindex");
		// Set the selected state
		newTab.setAttribute("aria-selected", "true");
		oldTab.removeAttribute("aria-selected");
		oldTab.setAttribute("tabindex", "-1");

		// Switch panel labelledby as it's a new tab but same panel.
		panels[0].setAttribute("aria-labelledby", newTab.id);

		// Get the indices of the new and old tabs to find the correct
		// tab panels to show and hide
		// let index = Array.prototype.indexOf.call(tabs, newTab);
		// let oldIndex = Array.prototype.indexOf.call(tabs, oldTab);
		// panels[oldIndex].hidden = true;
		// panels[index].hidden = false;

		// Switch to new filter
		switchFilter(e, newTab);
	};

	const switchFilter = (e, newTab) => {
		const filterValue = newTab.dataset.filter;
		current_category = filterValue;

		if ($(".posts-grid").length) {
			load_more_press_release(e, $(".ajax_read_more_pr"), filterValue, true);
		}

		if ($(".news-grid").length) {
			load_more_news(e, $(".ajax_read_more"));
		}

		if ($(".posts-rr-grid").length) {
			const filterTerm = newTab.dataset.term;
			load_more_rr(e, $(".ajax_read_more_rr"), filterValue, true, filterTerm);
		}
	};

	tabsList.forEach((tabList) => {
		// Select all tabs
		const tabs = tabList.querySelectorAll("button");

		// Add the tablist role to the first <ul> in the .tabbed container
		tabList.setAttribute("role", "tablist");

		// Add semantics are remove user focusability for each tab
		Array.prototype.forEach.call(tabs, (tab, i) => {
			tab.setAttribute("role", "tab");
			tab.setAttribute("id", "tab" + (i + 1));
			tab.setAttribute("tabindex", "-1");
			tab.parentNode.setAttribute("role", "presentation");

			// Handle clicking of tabs for mouse users
			tab.addEventListener("click", (e) => {
				e.preventDefault();
				let currentTab = tabList.querySelector("[aria-selected]");
				if (e.currentTarget !== currentTab) {
					switchTab(currentTab, e.currentTarget, e);
				}
			});

			// Handle keydown events for keyboard users
			tab.addEventListener("keydown", (e) => {
				// Get the index of the current tab in the tabs node list
				let index = Array.prototype.indexOf.call(tabs, e.currentTarget);
				// Work out which key the user is pressing and
				// Calculate the new tab's index where appropriate
				let dir =
					e.which === 37
						? index - 1
						: e.which === 39
						? index + 1
						: e.which === 40
						? "down"
						: null;
				if (dir !== null) {
					e.preventDefault();
					// If the down key is pressed, move focus to the open panel,
					// otherwise switch to the adjacent tab
					dir === "down"
						? panels[i].focus()
						: tabs[dir]
						? switchTab(e.currentTarget, tabs[dir], e)
						: void 0;
				}
			});
		});

		// Add tab panel semantics and hide them all
		Array.prototype.forEach.call(panels, (panel, i) => {
			panel.setAttribute("role", "tabpanel");
			panel.setAttribute("tabindex", "-1");
			let id = panel.getAttribute("id");
			panel.setAttribute("aria-labelledby", tabs[i].id);
			panel.hidden = false;
		});

		// Initially activate the first tab and reveal the first tab panel
		tabs[0].removeAttribute("tabindex");
		tabs[0].setAttribute("aria-selected", "true");
		panels[0].hidden = false;
	});
}

newsListingInit();

// A.8. END -----------------------------------------------------------------------------------------------------------

// A.9. Ajax Load More -----------------------------------------------------------------------------------------------
function check_load_more_items(current, button, grid) {
	const per_page = button.attr("data-per-page")
		? button.attr("data-per-page")
		: 6;
	const itemCount = per_page * current;
	const items = grid.children().find(".text-link");

	if (items && items.length >= itemCount) {
		button.removeAttr("hidden");
	} else {
		button.attr("hidden", "");
	}
}

function focus_load_more_item(current, button, grid) {
	const per_page = button.attr("data-per-page")
		? button.attr("data-per-page")
		: 6;
	const itemCount = per_page * (current - 1);
	const items = grid.children().find(".text-link");
	const item = items[itemCount];

	if (item) item.focus();
}

function load_more_news(e, button) {
	e.preventDefault();

	const data = {
		action: "loadmore_ajax_handler",
		query: scripts_params.posts,
		page: scripts_params.current_page,
	};

	$.ajax({
		url: scripts_params.ajaxurl,
		data: data,
		type: "POST",
		beforeSend: function (xhr) {
			button.text("Loading...");
		},
		success: function (data) {
			if (data) {
				button.text("View more");

				$(".news-grid").append(data);

				scripts_params.current_page++;

				if (
					scripts_params.current_page.toString() ===
					scripts_params.max_page.toString()
				) {
					button.remove();
				}
			} else {
				button.remove();
			}
		},
		complete: function () {
			focus_load_more_item(
				scripts_params.current_page,
				button,
				$(".news-grid")
			);
		},
	});
}

if ($(".ajax_read_more").length) {
	$(".ajax_read_more").click(function (e) {
		load_more_news(e, $(this));
	});
}
// A.9. END ----------------------------------------------------------------------------------------------------------

// A.10. Latest News -----------------------------------------------------------------------------------------------

// A.10. END ----------------------------------------------------------------------------------------------------------

// A.11. Ajax Load More for PR pages ----------------------------------------------------------------------------------
function build_pr_query(taxonomy) {
	const baseQuery =
		typeof posts_pr === "string" ? JSON.parse(posts_pr) : { ...posts_pr };
	const query = { ...baseQuery, paged: 1 };

	if (taxonomy && taxonomy !== "*") {
		query.category_name = taxonomy;
	} else {
		delete query.category_name;
	}

	return query;
}

function load_more_press_release(e, button, taxonomy = null, reset = false) {
	console.log('Debug: load_more_press_release');
	e.preventDefault();

	if (reset) {
		current_page_pr = 0;
	}

	const query = build_pr_query(taxonomy || current_category);
	const data = {
		action: "loadmore_ajax_handler",
		query: JSON.stringify(query),
		page: current_page_pr,
	};

	if (query.category_name) {
		data.category_name = query.category_name;
	}

	$.ajax({
		url: scripts_params.ajaxurl,
		data: data,
		type: "POST",
		beforeSend: function (xhr) {
			button.text("Loading...");
		},
		success: function (data) {
			if (data) {
				button.text("View more");

				if (reset) {
					$(".posts-grid").html(data);
					button.removeAttr("hidden");
					current_page_pr = 1;
				} else {
					$(".posts-grid").append(data);
					current_page_pr++;
				}

				if (current_page_pr.toString() === max_page_pr.toString()) {
					button.attr("hidden", "");
				}
			} else {
				button.attr("hidden", "");
			}
		},
		complete: function () {
			check_load_more_items(current_page_pr, button, $(".posts-grid"));

			if (!reset) {
				focus_load_more_item(current_page_pr, button, $(".posts-grid"));
			}
		},
	});
}

$(".ajax_read_more_pr").click(function (e) {
	load_more_press_release(e, $(this));
});
// A.11. END ---------------------------------------------------------------------------------------------------------

// A.11. Ajax Load More for RR pages ----------------------------------------------------------------------------------
function build_rr_query(taxonomy, term) {
	const baseQuery =
		typeof posts_rr === "string" ? JSON.parse(posts_rr) : { ...posts_rr };
	const query = { ...baseQuery, paged: 1 };

	if (taxonomy && taxonomy !== "*") {
		query.tax_query = [
			{
				taxonomy: term,
				field: "slug",
				terms: taxonomy,
			},
		];
	} else {
		delete query.tax_query;
	}

	return query;
}

function load_more_rr(
	e,
	button,
	taxonomy = null,
	reset = false,
	term = "rr_category"
) {
	e.preventDefault();

	if (reset) {
		current_page_rr = 0;
	}

	const query = build_rr_query(taxonomy || current_category, term);
	const data = {
		action: "loadmore_ajax_handler",
		query: JSON.stringify(query),
		page: current_page_rr,
	};

	$.ajax({
		url: scripts_params.ajaxurl,
		data: data,
		type: "POST",
		beforeSend: function (xhr) {
			button.text("Loading...");
		},
		success: function (data) {
			if (data) {
				button.text("View more");

				if (reset) {
					$(".posts-rr-grid").html(data);
					button.removeAttr("hidden");
					current_page_rr = 1;
				} else {
					$(".posts-rr-grid").append(data);
					current_page_rr++;
				}

				if (current_page_rr.toString() === max_page_rr.toString()) {
					button.attr("hidden", "");
				}
			} else {
				button.attr("hidden", "");
			}
		},
		complete: function () {
			if (!reset) {
				focus_load_more_item(current_page_pr, button, $(".posts-grid"));
			}
		},
	});
}

$(".ajax_read_more_rr").click(function (e) {
	load_more_rr(e, $(this));
});
// A.11. END ---------------------------------------------------------------------------------------------------------

// A.12. Scroll to # ----------------------------------------------------------------------------------

var speed = 1000;

// check for hash and if div exist... scroll to div
var hash = window.location.hash;
if ($(hash).length) scrollToID(hash, speed);

function scrollToID(id, speed) {
	var offSet = 150;
	var obj = $(id).offset();
	var targetOffset = obj.top - offSet;
	$("html,body").animate({ scrollTop: targetOffset }, speed);
}

// A.12. END ---------------------------------------------------------------------------------------------------------

// A.13. START -------------------------------------------------------------------------------------------------------
var modal_animation_time = 500;

$(".social_recycling_locator").on("click", function (e) {
	e.preventDefault();
	var modal = $("#search-modal");
	open_modal(modal);
});

function modal_focus_trap(element) {
	if (!element) return;

	const focusableElements = element.querySelectorAll(
		'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
	);
	const firstFocusableElement = focusableElements[0];
	const lastFocusableElement = focusableElements[focusableElements.length - 1];

	element.addEventListener("keydown", function (e) {
		if (!e.shiftKey && e.key === "Tab") {
			if (document.activeElement === lastFocusableElement) {
				firstFocusableElement.focus();
				e.preventDefault();
			}
		} else if (e.shiftKey && e.key === "Tab") {
			if (document.activeElement === firstFocusableElement) {
				lastFocusableElement.focus();
				e.preventDefault();
			}
		}
	});
}

function open_modal(modal) {
	modal.fadeIn(modal_animation_time).attr("aria-hidden", "false");

	modal_focus_trap(modal[0]);
	$(".close-modal").focus();

	modal
		.find(".close-modal")
		.off()
		.on("click", function (e) {
			e.preventDefault();
			close_modal(modal);
		});
}

function close_modal(modal) {
	modal.attr("aria-hidden", "true").fadeOut(modal_animation_time);

	$(".social_recycling_locator").focus();
}
// A.13. END ---------------------------------------------------------------------------------------------------------

// A.13. Ajax Load More -----------------------------------------------------------------------------------------------
$(".search_ajax_read_more").click(function (e) {
	e.preventDefault();
	var button = $(this),
		data = {
			action: "search_loadmore_ajax_handler",
			query: posts_sr,
			page: current_page_sr,
		};
	$.ajax({
		url: scripts_params.ajaxurl,
		data: data,
		type: "POST",
		beforeSend: function (xhr) {
			button.text("Loading...");
		},
		success: function (data) {
			if (data) {
				$("#search-results-container").append(data);
				const items = $("#search-results-container");
				current_page_sr++;
				button.text("View more");
				if (current_page_sr.toString() === max_page_sr.toString()) {
					button.remove();
				}
				focus_load_more_item(current_page_sr, button, items);
			} else {
				button.remove();
			}
		},
	});
});
// A.13. END ----------------------------------------------------------------------------------------------------------

const menuToggle = document.querySelector(".primary-nav-toggle");
const header = document.querySelector(".site-header");
const mainContent = document.querySelector("#gutenberg_body_wide");
const footer = document.querySelector("#footer");

$(".locator-form-close").on("click", function (e) {
	e.preventDefault();
	var modal = $(".locator-form");
	modal.attr("aria-hidden", "true");
	header.removeAttribute("inert");
	mainContent.removeAttribute("inert");
	footer.removeAttribute("inert");
});

/**
 * Close open flyout menu
 */
const closeFlyouts = () => {
	const flyoutLinks = document.querySelectorAll(
		'.primary-nav__link[aria-expanded="true"]'
	);

	Array.prototype.forEach.call(flyoutLinks, (item) => {
		item.setAttribute("aria-expanded", "false");
	});
};

/**
 * Handles the showing and hiding functionality
 *
 * @param {Object} e Toggle button
 * @param {Boolean} isTopLevel If the nav item is top level
 */
const flyoutToggle = (e, isTopLevel = false) => {
	if (e.getAttribute("aria-expanded") === "false") {
		if (isTopLevel) closeFlyouts();
		e.setAttribute("aria-expanded", "true");
	} else {
		e.setAttribute("aria-expanded", "false");
	}
};

/**
 * Close flyouts and mobile nav
 */
const closeFlyoutsAndNav = () => {
	closeFlyouts();
	menuToggle.setAttribute("aria-expanded", "false");
	mainContent.removeAttribute("inert");
	footer.removeAttribute("inert");
};

/**
 * Changes nav items with children to a button
 *
 * @param {Object} e Element to change
 * @param {Boolean} isTopLevel If the nav item is top level
 */
const changeToNavButton = (e, isTopLevel = true) => {
	const d = document.createElement("button");
	d.innerHTML = e.innerHTML;
	d.setAttribute("type", "button");
	d.setAttribute("aria-expanded", "false");
	d.classList.add("btn--no-style");
	isTopLevel
		? d.classList.add("primary-nav__link")
		: d.classList.add("primary-nav__sub-link");
	d.classList.add("header-nav__link");
	d.classList.add("fancy-link-hover");
	if (e.parentNode.classList.contains("current-menu-ancestor"))
		d.setAttribute("aria-current", "true");
	d.dataset.state = e.dataset.state || false;

	d.addEventListener("click", () => {
		flyoutToggle(d, isTopLevel);
	});

	e.parentNode.replaceChild(d, e);
};

/**
 * Initilise nav
 */
const initNav = () => {
	// Get all nav items with children and add click event to toggle visibility
	const topLevelItems = document.querySelectorAll(
		"#menu-main-menu > .menu-item > a"
	);
	const topLevelHasChildren = document.querySelectorAll(
		".menu > .menu-item-has-children"
	);
	const subLevelHasChildren = document.querySelectorAll(
		".sub-menu > .menu-item-has-children"
	);

	Array.prototype.forEach.call(topLevelItems, (item) => {
		item.classList.add("btn--no-style");
		item.classList.add("primary-nav__link");
		item.classList.add("header-nav__link");
		item.classList.add("fancy-link-hover");
	});

	Array.prototype.forEach.call(topLevelHasChildren, (child) => {
		const link = child.querySelector("a");
		changeToNavButton(link);
	});

	Array.prototype.forEach.call(subLevelHasChildren, (child) => {
		const link = child.querySelector("a");
		changeToNavButton(link, false);
	});

	menuToggle.addEventListener("click", () => {
		const menuExpanded = menuToggle.getAttribute("aria-expanded") === "false";
		menuToggle.setAttribute("aria-expanded", menuExpanded);

		if (menuExpanded) {
			mainContent.setAttribute("inert", "true");
			footer.setAttribute("inert", "true");
		} else {
			mainContent.removeAttribute("inert");
			footer.removeAttribute("inert");
		}
	});

	// Close flyout if click outside of it on desktop
	document.addEventListener("click", (e) => {
		// If user clicks inside the element, do nothing
		if (e.target.closest(".menu-item-has-children")) {
			return;
		}

		closeFlyouts();
	});

	// Close submenus and main menu (on mobile) if ESC key is pressed
	document.addEventListener("keydown", (e) => {
		if (e.key !== "Escape") {
			return;
		}

		$(".locator-form").attr("aria-hidden", "true");

		closeFlyoutsAndNav();
	});

	// Close mobile menu and remove inert attribute on resize
	const menuResize = debounce(function () {
		if (window.innerWidth > 895) {
			closeFlyoutsAndNav();
		}
	}, 1000);

	window.addEventListener("resize", menuResize);
};

initNav();

// A. END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

function init_asset_nav() {
	// Create a variable that contains the asset navigation.
	var navigation = jQuery("#campaigns-navigation");

	// Check if the navigation exists. We do not want to run anything if it does not.
	if (navigation.length > 0) {
		// Remove the disabled class as soon as this javaScript is available.
		navigation.removeClass("disabled");
		// Create a variable that contains the clickable buttons and folders and the container for the latest assets.
		var buttons = jQuery(".mcs-campaign-name"),
			folders = jQuery(".mcs-folder-name"),
			container = jQuery("#latest-assets");

		// Check if those buttons exists on the page.
		if (buttons.length > 0) {
			// If they do, the bind a click event to them.
			buttons.on("click", function (e) {
				// Prevent default action if button was changed to anchor tag instead of button.
				e.preventDefault();
				// Create variables for the button clicked and its sub navigation.
				var button = jQuery(this),
					subNav = button.siblings(".mcs-campaign-assets"),
					openFolder = jQuery(".mcs-folder-name.open"),
					openFolderSubNav = openFolder.siblings(".mcs-campaign-assets"),
					data,
					text = "";

				// Check that the navigation does not have the disabled class. If this class exists, we don't want to do anything.
				if (!navigation.hasClass("disabled")) {
					// If it does not have the class, it means a click has taken place and we want to disable it.
					navigation.addClass("disabled");
					// Check if the button clicked was already open.
					if (button.hasClass("open")) {
						// If it was, then simply remove the open class and close the sub navigation.
						button.removeClass("open");
						subNav.slideUp(300);

						// Set the AJAX data variable.
						data = {
							action: "get_latest_assets_html",
						};
						text = "From all non-restricted campaigns";
					} else {
						// If it was not open, we need variables for any open buttons, folders and their sub navigation.
						var openButton = jQuery(".mcs-campaign-name.open"),
							openSubNav = openButton.siblings(".mcs-campaign-assets");
						// Check if any open buttons exists.
						if (openButton.length > 0) {
							// If it does, we need to close it.
							openButton.removeClass("open");
							openSubNav.slideUp(300);
						}
						// Open the clicked button and its sub navigation.
						button.addClass("open");
						subNav.slideDown(300);

						// Set the AJAX data variable.
						data = {
							action: "get_latest_campaign_assets_html",
							id: button.data("id"),
						};
						text = "From " + button.text();
					}
					// Check if any open folders exists.
					if (openFolder.length > 0) {
						// If it does, we need to close it
						openFolder.removeClass("open");
						openFolderSubNav.slideUp(300);
					}
					// Check if the ajaxUrl variable is available for use.
					if (typeof scripts_params.ajaxurl !== "undefined") {
						// Set loader top position.
						set_loader_top_position(container);
						// Show preloader
						var preloader = container.find(".m-preloader");
						preloader.fadeIn(300);
						// Fetch the 6 latest assets for this campaign.
						jQuery.post(scripts_params.ajaxurl, data, function (response) {
							// Replace the HTML.
							jQuery("#latest-asset-container").empty().html(response);
							jQuery("#latest-assets .a-angled-heading + p").text(text);
							// Hide preloader
							preloader.fadeOut(300);
							// Remove the disabled class from the navigation.
							navigation.removeClass("disabled");
						});
					}
				}
			});
		}

		// Check if those folders exists on the page.
		if (folders.length > 0) {
			// If they do, the bind a click event to them.
			folders.on("click", function (e) {
				// Prevent default action if folder was changed to anchor tag instead of button.
				e.preventDefault();
				// Create variables for the folder clicked and its sub navigation.
				var folder = jQuery(this),
					folderSubNav = folder.siblings(".mcs-campaign-assets"),
					openCampaign = jQuery(".mcs-campaign-name.open"),
					data,
					text = "";

				// Check that the navigation does not have the disabled class. If this class exists, we don't want to do anything.
				if (!navigation.hasClass("disabled")) {
					// If it does not have the class, it means a click has taken place and we want to disable it.
					navigation.addClass("disabled");
					// Check if the folder clicked was already open.
					if (folder.hasClass("open")) {
						// If it was, then simply remove the open class and close the sub navigation.
						folder.removeClass("open");
						folderSubNav.slideUp(300);

						// Set the AJAX data variable.
						data = {
							action: "get_latest_campaign_assets_html",
							id: openCampaign.data("id"),
						};
						text = "From " + openCampaign.text();
					} else {
						// If it was not open, we need variables for any open folders and their sub navigation.
						var openFolder = jQuery(".mcs-folder-name.open"),
							openFolderSubNav = openFolder.siblings(".mcs-campaign-assets");
						// Check if any open folders exists.
						if (openFolder.length > 0) {
							// If it does, we need to close it
							openFolder.removeClass("open");
							openFolderSubNav.slideUp(300);
						}
						// Open the clicked folder and its sub navigation.
						folder.addClass("open");
						folderSubNav.slideDown(300);

						// Set the AJAX data variable.
						data = {
							action: "get_latest_folder_assets_html",
							id: folder.data("id"),
						};
						text = "From the " + folder.text() + " Folder";
					}
					// Check if the ajaxUrl variable is available for use.
					if (typeof scripts_params.ajaxurl !== "undefined") {
						// Set loader top position.
						set_loader_top_position(container);
						// Show preloader
						var preloader = container.find(".m-preloader");
						preloader.fadeIn(300);
						// Fetch the 6 latest assets for this campaign or folder.
						jQuery.post(scripts_params.ajaxurl, data, function (response) {
							// Replace the HTML.
							jQuery("#latest-asset-container").empty().html(response);
							jQuery("#latest-assets .a-angled-heading + p").text(text);
							// Hide preloader
							preloader.fadeOut(300);
							// Remove the disabled class from the navigation.
							navigation.removeClass("disabled");
						});
					}
				}
			});
		}
	}
}
init_asset_nav();

function set_loader_top_position(container) {
	var posTop = jQuery(window).innerHeight() - container.offset().top;

	if (posTop > 50) {
		container.find(".m-loader").css({
			top: posTop / 2 + "px",
		});
	}
}

// Video player hover function
// jQuery('.lab-information-image-video').hover(function() {
//         jQuery(this).find('.embed-container').css('z-index', 25);
//     },function() {
//         jQuery(this).find('.embed-container').css('z-index', 10);
//     }
// );

/**
 * Update Gravity form password strength indicator
 * - Adds aria live and role to elements
 */
function passwordIndicatorScreenReader() {
	const indicators = document.querySelectorAll(".gfield_password_strength");

	if (!indicators.length) return;

	Array.prototype.forEach.call(indicators, (indicator) => {
		indicator.setAttribute("role", "status");
		indicator.setAttribute("aria-atomic", "true");
	});
}

passwordIndicatorScreenReader();

// FILE END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

});
(function () {
  /**
   * Electronics Category Navigation
   *
   * Handles category navigation and item display based on category selection and URL hash.
   *
   * @date    04/07/2024
   * @since   1.0.0
   */

  // Variables
  const categoriesLinks = document.querySelectorAll(
    ".small-card[data-category]"
  );
  const backButtons = document.querySelectorAll(".electronics-listing__btn");
  const catList = document.querySelector(
    ".electronics-listing__cat-list-section"
  );
  const itemsList = document.querySelectorAll(
    ".electronics-listing__items-list"
  );

  // Adding click event listeners to category links
  categoriesLinks.forEach((link) => {
    link.addEventListener("click", function (event) {
      event.preventDefault();
      const category = this.getAttribute("data-category");
      toggleCategories(false); // Hide categories
      showItemsList(category); // Show items based on category
      window.history.pushState("", document.title, `#${category}`); // Update URL hash
      document.getElementById(`${category}`).querySelector("a").focus(); // Focus on the selected category
    });
  });

  // Adding click event listeners to back to categories list buttons in caterogy sections
  backButtons.forEach((button) => {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      toggleCategories(true); // Show categories
      showItemsList(null); // Hide all items lists
      window.history.pushState(
        "",
        document.title,
        window.location.pathname + window.location.search
      ); // Reset URL
      catList.querySelector("a").focus(); // Focus on the category list
    });
  });

  // Function to show/hide items lists based on category
  function showItemsList(category) {
    itemsList.forEach((list) => {
      const categories = list.getAttribute("data-category");
      if (category && categories.includes(category)) {
        list.setAttribute("data-display", "show"); // Show items list if it matches the category
      } else {
        list.setAttribute("data-display", "hide"); // Hide items list if it doesn't match
      }
    });
  }

  // Function to toggle categories list visibility
  function toggleCategories(show) {
    if (show) {
      catList.setAttribute("data-display", "show"); // Show category list
    } else {
      catList.setAttribute("data-display", "hide"); // Hide category list
    }
  }

  // Check if there's a category in the URL hash on page load
  const currentCategory = window.location.hash.substring(1);
  if (currentCategory) {
    showItemsList(currentCategory); // Show items based on URL hash category
    toggleCategories(false); // Hide categories
  }
})();

(function($){

  /**
   * LAB - Logo Slider
   *
   * Adds custom JavaScript to the block HTML.
   *
   * @date    23/01/2020
   * @since   1.0.0
   *
   * @param   object $block The block jQuery element.
   * @param   object attributes The block attributes (only available when editing).
   * @return  void
   */
  var initializeBlock = function( $block ) {
    var deadline = $('#countdown-container').attr('data-deadline');
    var expire_text = $('#countdown-container').attr('data-expire-text');
    var countDownDate = new Date(deadline).getTime();

    var x = setInterval(function() {

      // Get today's date and time
      var now = new Date().getTime();

      // Find the distance between now and the count down date
      var distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Display the result in the element with id="countdown_container"
      document.getElementById("countdown-container").innerHTML = "<div class='countdown-timer'>" +
        "<div class='days digit'>"+ formatTime(days) +"<span>days</span></div>" +
        "<div class='hours digit'>"+ formatTime(hours) +"<span>hours</span></div>" +
        "<div class='minutes digit'>"+ formatTime(minutes) +"<span>minutes</span></div>" +
        //"<div class='seconds'>"+seconds+"<span>seconds</span></div>" +
        "</div>";

      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(x);
        document.getElementById("countdown-container").innerHTML = "<span class='countdown-expired'>"+expire_text+"</span>";
      }
    }, 1000);

  };
  
  var formatTime = function(time){
    if(time.toString().length <= 1){
      return '0' + time;
    }
    return time;
  };

  // Initialize each block on page load (front end).
  $('.lab_countdown').each(function () {
    initializeBlock($(this));
  });

  // Initialize dynamic block preview (editor).
  if( window.acf ) {
    window.acf.addAction( 'render_block_preview/type=lab_countdown', initializeBlock );
  }

})(jQuery);

(function($){

    /**
     * LAB - Double-Sided Carousel
     *
     * Adds custom JavaScript to the block HTML.
     *
     * @date    23/01/2020
     * @since   1.0.0
     *
     * @param   object $block The block jQuery element.
     * @param   object attributes The block attributes (only available when editing).
     * @return  void
     */

    var initializeBlock = function( $block ) {

        var wrapper = $block.find('.gallery-wrapper');
        if(!wrapper.hasClass('no-carousel')){
            var owl = $block.find('.gallery-carousel');

            owl.owlCarousel({
                animateOut:'fadeOut',
                animateIn:'fadeIn',
                items:1,
                loop:true,
                mouseDrag:false,
                touchDrag: false,
                pullDrag: false,
                center:true,
                freeDrag:false,
                dots:false,
                responsiveClass:true,
                autoplay:true,
                autoplayTimeout:9000
            });

            $('.nav-btn.owl-prev').on('click',function(){
                owl.trigger('prev.owl.carousel');
            });

            $('.nav-btn.owl-next').click('click',function(){
                owl.trigger('next.owl.carousel');
            });
        } else {
            $block.find('.o-gallery-block').removeClass('owl-carousel gallery-carousel');
        }

    };

    // Initialize each block on page load (front end).
    $('.lab_double_sided_carousel').each(function () {
        initializeBlock($(this));
    });

    // Initialize dynamic block preview (editor).
    if( window.acf ) {
        window.acf.addAction( 'render_block_preview/type=lab_double_sided_carousel', initializeBlock );
    }

})(jQuery);

(function($){

    /**
     * LAB - FAQ Quick Links
     *
     * Adds custom JavaScript to the block HTML.
     *
     * @date    23/01/2020
     * @since   1.0.0
     *
     * @param   object $block The block jQuery element.
     * @param   object attributes The block attributes (only available when editing).
     * @return  void
     */
    var initializeBlock = function( $block ) {

    };

    // Initialize each block on page load (front end).
    $('.lab-faq-quick-links').each(function () {
        initializeBlock($(this));
    });

    // Initialize dynamic block preview (editor).
    if( window.acf ) {
        window.acf.addAction( 'render_block_preview/type=faq_quick_links', initializeBlock );
    }

})(jQuery);

(function($){

  /**
   * LAB - Four Blocks
   *
   * Adds custom JavaScript to the block HTML.
   *
   * @date    23/01/2020
   * @since   1.0.0
   *
   * @param   object $block The block jQuery element.
   * @param   object attributes The block attributes (only available when editing).
   * @return  void
   */
  var initializeBlock = function( $block ) {

    $block.find('.owl-carousel').owlCarousel({
      loop: true,
      nav: true,
      navText: ['',''],
      dots: true,
      responsive:{
        0: {
          items: 1,
          nav: false
        },
        768: {
          items: 2,
          nav: true,
        },
        992: {
          items: 3
        },
        1200: {
          items: 4
        }
      }
    });
  };

  // Initialize each block on page load (front end).
  $('.lab-four-blocks').each(function(){
    initializeBlock($(this));
  });

  // Initialize dynamic block preview (editor).
  if( window.acf ) {
    window.acf.addAction( 'render_block_preview/type=lab_four_blocks', initializeBlock );
  }
  
})(jQuery);

(function ($) {
	/**
	 * LAB - Header
	 *
	 * Adds custom JavaScript to the block HTML.
	 *
	 * @date    04/02/2020
	 * @since   1.0.0
	 *
	 * @param   object $block The block jQuery element.
	 * @param   object attributes The block attributes (only available when editing).
	 * @return  void
	 */

	var initializeBlock = function ($block) {
		var desktopImageToPreload = $block.data("desktop-preload");
		var mobileImageToPreload = $block.data("mobile-preload");

		var image = new Image();

		if (jQuery(window).width() > 600) {
			image.src = desktopImageToPreload;
		} else {
			image.src = mobileImageToPreload;
		}

		image.onload = function () {
			showImage($block.find(".m-preloader"));
		};
		image.onerror = function () {
			showImage($block.find(".m-preloader"));
		};
	};

	function showImage(preloader) {
		var text = prepHeading();
		preloader.parent().addClass("preloaded");
		preloader.fadeOut(300, function () {
			setTimeout(function () {
				typeHeading(text.split(""));
			}, 500);
			$(this).remove();
		});
	}

	function prepHeading() {
		var heading = $(".lab-header h1"),
			headingText = heading.text();
		heading.text("");
		return headingText;
	}

	function typeHeading(text) {
		if (text.length > 0) {
			var heading = $(".lab-header h1");

			setTimeout(function () {
				heading.text(heading.text() + text[0]);
				text.shift();
				typeHeading(text);
			}, 50);
		}
	}

	// Initialize each block on page load (front end).
	$(".lab-header").each(function () {
		initializeBlock($(this));
	});

	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction(
			"render_block_preview/type=lab_header",
			initializeBlock
		);
	}
})(jQuery);

(function ($) {
	/**
	 * LAB - Hero with Snippet
	 *
	 * Adds custom JavaScript to the block HTML.
	 *
	 * @date    04/02/2020
	 * @since   1.0.0
	 *
	 * @param   object $block The block jQuery element.
	 * @param   object attributes The block attributes (only available when editing).
	 * @return  void
	 */
	var initializeBlock = function ($block) {
		var desktopImageToPreload = $block.find("[data-desktop-preload]");
		var mobileImageToPreload = $block.find("[data-mobile-preload]");
		var image = new Image();

		if (jQuery(window).width() > 600) {
			image.src = desktopImageToPreload.data("desktop-preload");
		} else {
			image.src = mobileImageToPreload.data("mobile-preload");
		}

		image.onload = function () {
			showImage($block.find(".m-preloader"));
		};
		image.onerror = function () {
			showImage($block.find(".m-preloader"));
		};
	};

	function showImage(preloader) {
		preloader.parent().addClass("preloaded");
		preloader.fadeOut(300, function () {
			$(this).remove();
		});
	}

	function prepHeading() {
		var heading = $(".lab-hero-with-snippet h1"),
			headingText = heading.text();
		heading.text("");
		return headingText;
	}

	// Initialize each block on page load (front end).
	$(".lab-hero-with-snippet").each(function () {
		initializeBlock($(this));
	});

	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction(
			"render_block_preview/type=lab_hero_with_snippet",
			initializeBlock
		);
	}
})(jQuery);

(function($){

  /**
   * LAB - Icon List
   *
   * Adds custom JavaScript to the block HTML.
   *
   * @date    04/02/2020
   * @since   1.0.0
   *
   * @param   object $block The block jQuery element.
   * @param   object attributes The block attributes (only available when editing).
   * @return  void
   */
  var initializeBlock = function( $block ) {
    var carousel = $block.find('.icon-list-carousel');
    if(carousel.length > 0){
      carousel.owlCarousel({
        loop: true,
        margin: 50,
        navigation: true,
				pagination: false,
				dots: false,
        autoplay: true,
        autoplayTimeout: 9000,
        navText: ['',''],
        responsive: {
          0: {
            items: 1,
            slideBy: 1,
            nav: false
          },
          500: {
            items: 3,
            slideBy: 1,
            nav: false
          },
          860: {
            items: 5,
            slideBy: 1,
            nav: true
          },
          1100: {
            items: 5,
            slideBy: 1,
            nav: true
          }
        },
      });
    }
  };
  


  // Initialize each block on page load (front end).
  $('.lab-icon-list').each(function () {
    initializeBlock($(this));
  });

  // Initialize dynamic block preview (editor).
  if( window.acf ) {
    window.acf.addAction( 'render_block_preview/type=lab_icon_list', initializeBlock );
  }

})(jQuery);


(function ($) {
	/**
	 * LAB - Information
	 *
	 * Adds custom JavaScript to the block HTML.
	 *
	 * @date    23/01/2020
	 * @since   1.0.0
	 *
	 * @param   object $block The block jQuery element.
	 * @param   object attributes The block attributes (only available when editing).
	 * @return  void
	 */
	/**
	 * Creates the video embed iframe node
	 *
	 * @param {String} videoId The video ID
	 * @param {String} videoType The video type (youtube/vimeo)
	 * @param {String} videoLabel The video label for analytics
	 * @returns {Node} Video embed
	 */
	function getIframe(embedId) {
		const docfrag = document.createDocumentFragment();
		const iframeNode = document.createElement("iframe");
		const allowAttr =
			"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";

		// Add iframe attributes
		iframeNode.setAttribute(
			"src",
			`https://www.youtube-nocookie.com/embed/${embedId}?rel=1&autoplay=1&enablejsapi=1`
		);
		iframeNode.setAttribute("width", "640");
		iframeNode.setAttribute("height", "360");
		iframeNode.setAttribute("frameborder", 0);
		iframeNode.setAttribute("allowfullscreen", "");
		iframeNode.setAttribute(
			"referrerpolicy",
			"strict-origin-when-cross-origin"
		);
		iframeNode.setAttribute("allowFullScreen", "");
		iframeNode.allow = allowAttr;

		docfrag.appendChild(iframeNode);
		return docfrag;
	}

	function youTubeGetID(url) {
		const [a, , b] = url
			.replace(/(>|<)/gi, "")
			.split(
				/^.*(?:(?:youtu\.?be(\.com)?\/|v\/|vi\/|u\/\w\/|embed\/|shorts\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/
			);
		if (b !== undefined) {
			return b.split(/[^0-9a-z_-]/i)[0];
		} else {
			return a;
		}
	}

	var initializeBlock = function ($block) {
		var carousel = $block.find(".lab-information-carousel");
		if (carousel.length > 0) {
			carousel.owlCarousel({
				items: 1,
				loop: true,
				margin: 50,
				autoplay: true,
				autoplayTimeout: 9000,
				onChange: imageSlide,
			});
		}

		function imageSlide() {
			var image_video = $block.find(".lab-information-image-video");
			setTimeout(function () {
				image_video.removeClass("show-initial");
			}, 9000);
			setTimeout(function () {
				var ref = $block
					.find(
						".lab-information-carousel .active .lab-information-carousel-slide"
					)
					.attr("data-slide");
				image_video.removeClass("show-slide");
				$block.find("." + ref).addClass("show-slide");
			}, 100);
		}

		var imageToPreload = $block.find(".lab-video-poster");
		if (imageToPreload.length > 0) {
			var image = new Image();
			image.src = imageToPreload.attr("src");
			image.onload = function () {
				$block
					.addClass("preloaded")
					.find(".m-preloader")
					.fadeOut(300, function () {
						$(this).remove();
					});
			};
		} else {
			$block.find(".m-preloader").fadeOut(300, function () {
				$(this).remove();
			});
		}

		var embedContainer = $block.find(".embed-container"),
			embedPlayer = $block.find("video"),
			youtubePlayer = $block.find("iframe"),
			poster = $block.find(".lab-hero-video-play"),
			embedUrl = embedContainer.data("src");

		const embedId = embedUrl ? youTubeGetID(embedUrl) : null;

		if (poster.length > 0) {
			$block
				.find(".lab-hero-video-icon")
				.on("click tap touchstart", function (e) {
					e.preventDefault();

					const iframe = getIframe(embedId);

					embedContainer.append(iframe);

					poster.fadeOut(300);
					$(this).parent().parent().css("overflow", "inherit");
					if (embedPlayer[0]) {
						embedPlayer[0].play();
					}
					if (youtubePlayer[0]) {
						var videoURL = $(youtubePlayer[0]).attr("src");
						$(youtubePlayer[0]).attr("src", videoURL + "&autoplay=1");
					}
				});
		}

		//IE 11 object fit fix
		if (document.documentMode || /Edge/.test(navigator.userAgent)) {
			$block.find(".lab-hero-video-play img").each(function () {
				var t = $(this),
					s = "url(" + t.attr("src") + ")",
					p = t.parent(),
					d = $("<div></div>");

				p.append(d);
				d.css({
					height: t.parent().css("height"),
					backgroundSize: "cover",
					backgroundRepeat: "no-repeat",
					backgroundPosition: "50% 20%",
					backgroundImage: s,
				});
				t.hide();
			});
		}
	};

	// Initialize each block on page load (front end).
	$(".lab-information").each(function () {
		initializeBlock($(this));
	});

	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction(
			"render_block_preview/type=lab_information",
			initializeBlock
		);
	}
})(jQuery);

(function ($) {
  /**
   * LAB - Large Icon Blocks
   *
   * Adds custom JavaScript to the block HTML.
   *
   * @date    23/01/2020
   * @since   1.0.0
   *
   * @param   object $block The block jQuery element.
   * @param   object attributes The block attributes (only available when editing).
   * @return  void
   */

  var initializeBlock = function ($block) {
    $(".o-card-grid").each(function () {
      var numItems = $(this).children().length;

      if (numItems == 3 || numItems == 0) {
        $(this).parent().addClass("o-block-stacked");
        $(this).children("._icon-card").addClass("col-100");
        $(this).addClass("_block-inline");
      } else {
        $(this).parent().addClass("o-block-inline");
        $(this).children("._icon-card").addClass("col-50");
        $(this).addClass("_block-grid");
        $(this).removeAttr("style");
      }
    });
  };

  // Initialize each block on page load (front end).
  $(".lab-large-icon-blocks").each(function () {
    initializeBlock($(this));
  });

  // Initialize dynamic block preview (editor).
  if (window.acf) {
    window.acf.addAction(
      "render_block_preview/type=lab_large_icon_blocks",
      initializeBlock
    );
  }
})(jQuery);

(function ($) {
  /**
   * LAB - Latest News
   *
   * Adds custom JavaScript to the block HTML.
   *
   * @date    23/01/2020
   * @since   1.0.0
   *
   * @param   object $block The block jQuery element.
   * @param   object attributes The block attributes (only available when editing).
   * @return  void
   */
  var initializeBlock = function ($block) {
    var carousel = $block.find(".lab-news-carousel");
    if (carousel.length > 0) {
      carousel.owlCarousel({
        loop: true,
        nav: true,
        responsive: {
          0: {
            items: 1,
            nav: false,
          },
          768: {
            items: 2,
            nav: true,
            navText: [
              '<div class="a-btn"><img loading="lazy" src="https://s3-eu-west-1.amazonaws.com/s3-bucket-recycleyourelectricals.org.uk/wp-content/uploads/2020/02/arrow-pointing-to-left.svg"></div>',
              '<div class="a-btn"><img loading="lazy" src="https://s3-eu-west-1.amazonaws.com/s3-bucket-recycleyourelectricals.org.uk/wp-content/uploads/2020/02/arrow-pointing-to-right.svg"></div>',
            ],
          },
          992: {
            items: 3,
            nav: true,
            navText: [
              '<div class="a-btn"><img loading="lazy" src="https://s3-eu-west-1.amazonaws.com/s3-bucket-recycleyourelectricals.org.uk/wp-content/uploads/2020/02/arrow-pointing-to-left.svg"></div>',
              '<div class="a-btn"><img loading="lazy" src="https://s3-eu-west-1.amazonaws.com/s3-bucket-recycleyourelectricals.org.uk/wp-content/uploads/2020/02/arrow-pointing-to-right.svg"></div>',
            ],
          },
        },
      });
    }
  };

  // Initialize each block on page load (front end).
  $(".lab-latest-news").each(function () {
    initializeBlock($(this));
  });

  // Initialize dynamic block preview (editor).
  if (window.acf) {
    window.acf.addAction(
      "render_block_preview/type=lab_latest_news",
      initializeBlock
    );
  }
})(jQuery);

(function ($) {
  /**
   * LAB - Locator
   *
   * Adds custom JavaScript to the block HTML.
   *
   * @date    04/02/2020
   * @since   1.0.0
   *
   * @param   object $block The block jQuery element.
   * @param   object attributes The block attributes (only available when editing).
   * @return  void
   */
  var initializeBlock = function ($block) {
    // INITIALISE VARIABLES
    var locator_results_form = $("#locator-results-frame-form"),
      locator_results_found = $("#locator-results-frame-found"),
      locator_results_frame = $("#locator-results-frame"),
      locator_filters_frame = $("#locator-filters-frame"),
      global_range_checkbox = $("#range_global"),
      search_radius = $("#search_radius"),
      locator_search_data_container = $("#locator-search-result-data"),
      locator_search_frame = $("#locator-search-result-frame");

    // LINK GOOGLE PLACES AUTOCOMPLETE TO LOCATION FIELDS - START
    $(".g_places_autocomplete").each(function () {
      google.maps.event.addDomListener(
        window,
        "load",
        google_places_initialize($(this).attr("id"))
      );
    });
    // LINK GOOGLE PLACES AUTOCOMPLETE TO LOCATION FIELDS - END

    // SET DEFAULT MAP LOCATION - START
    if (
      localStorage.getItem("google_result") === "" ||
      localStorage.getItem("google_result") === "null" ||
      localStorage.getItem("google_result") === null ||
      localStorage.getItem("google_result") === "undefined" ||
      localStorage.getItem("google_result") === undefined
    ) {
      var london_latlng = {
        lat: 51.5287718,
        lng: -0.2416804,
      };
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({ location: london_latlng }, function (results, status) {
        localStorage.setItem("google_result", JSON.stringify(results[0]));
        locator_results_form.trigger("submit");
      });
    }
    // SET DEFAULT MAP LOCATION - END

    // LOOKUP POSTED STRING - START
    var posted_string = jQuery("#posted_string_id").data("postedstring");

    var handleSuggestions = function (predictions, status) {
      /** ERROR HANDLING **/
      if (status != google.maps.places.PlacesServiceStatus.OK) {
        if (!predictions && status == "ZERO_RESULTS") {
          alert(
            "Sorry, that location has not been recognised, please try again. Please note that we can only search UK locations."
          );
        }

        return;
      }
      /** HANDLE PREDICTIONS **/
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode(
        { placeId: predictions[0].place_id },
        function (results, status) {
          localStorage.setItem("google_result", JSON.stringify(results[0]));
          // input.value = results[0].formatted_address;
          $("#locator-results-location").val(results[0].formatted_address);
          $("#locator-results-frame-form").trigger("submit");
        }
      );
    };
    var service = new google.maps.places.AutocompleteService();
    service.getPlacePredictions(
      { input: posted_string, componentRestrictions: { country: ["GB", "IM", "GG", "JE"] } },
      handleSuggestions
    );
    // LOOKUP POSTED STRING - END

    // FILTER SYSTEM ON PAGE LOAD - START
    var filters = get_page_filters();
    if (
      localStorage.getItem("search_filters") === "" ||
      localStorage.getItem("search_filters") === null ||
      localStorage.getItem("search_filters") === undefined
    ) {
      localStorage.setItem("search_filters", JSON.stringify(filters));
      localStorage.setItem("search_filter_count", "0");
    }
    // FILTER SYSTEM ON PAGE LOAD - END

    // MOVE HOVER & ACTIVE CLASS HANDLER - START
    locator_results_found
      .on("mouseenter", ".location-entry", function (e) {
        update_map_marker_image(
          $(".markerId" + $(this).data("result-number")),
          "https://s3-eu-west-1.amazonaws.com/s3-bucket-recycleyourelectricals.org.uk/wp-content/uploads/2020/02/pin-pink.png"
        );
      })
      .on("mouseleave", ".location-entry", function (e) {
        update_map_marker_image(
          $(".markerId" + $(this).data("result-number")),
          "https://s3-eu-west-1.amazonaws.com/s3-bucket-recycleyourelectricals.org.uk/wp-content/uploads/2020/02/pin-grey.png"
        );
      });
    // MOVE HOVER & ACTIVE CLASS HANDLER - END

    // HANDLE SEE MORE DETAILS CLICK - START
    locator_results_found.on("click", ".location-entry-details", function (e) {
      e.preventDefault();

      // Get post ID
      var post_id = $(this).data("id");
      var result_number = $(this).data("result-number");

      // Set details frame to show spinner
      locator_search_data_container.html(
        '<div class="m-preloader"><div class="m-loader"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div></div>'
      );

      // Swop Frames to detail frame
      navigate_to_frame(locator_search_frame);

      // Add active map marker state
      activate_map_marker($(".markerId" + result_number));

      // GET THE DETAILS AND PUSH HTML INTO CONTAINER
      var data = {
        action: "get_search_result_location_html",
        post_id: post_id,
        result_number: result_number,
        searched_location: JSON.parse(localStorage.getItem("google_result")),
      };
      jQuery.post(scripts_params.ajaxurl, data, function (response) {
        locator_search_data_container.html(response);
      });
    });
    // HANDLE SEE MORE DETAILS CLICK - END

    /**
     var marker_id = $(this).attr('data-result-number');
     var marker = $('img[src="https://s3-eu-west-1.amazonaws.com/s3-bucket-recycleyourelectricals.org.uk/wp-content/uploads/2020/02/pin-grey.svg?markerId='+marker_id+'"]')
     marker.attr('src', 'https://s3-eu-west-1.amazonaws.com/s3-bucket-recycleyourelectricals.org.uk/wp-content/uploads/2020/02/pin-pink.svg?markerId='+marker_id);
     */

    // OPEN FILTERS BUTTON HANDLER - START
    $("#locator-filter-btn").on("click", function (e) {
      updateFilterFields();
      navigate_to_frame(locator_filters_frame);
    });
    // OPEN FILTERS BUTTON HANDLER - END

    // FILTERS BACK BUTTON HANDLER - START
    $("#locator-filters-back-btn").on("click", function (e) {
      navigate_to_frame(locator_results_frame);
      locator_results_form.trigger("submit");
    });
    // FILTERS BACK BUTTON HANDLER - END

    // FILTER RANGE INDICATOR SCRIPT - START
    global_range_checkbox.on("change", function (e) {
      if ($(this).is(":checked")) {
        search_radius.attr("disabled", "disabled");
        localStorage.setItem("google_search_radius", "global");
      } else {
        search_radius.removeAttr("disabled");
        localStorage.setItem("google_search_radius", search_radius.val());
      }
    });
    search_radius.on("change", function (e) {
      $("#range_value").html($(this).val());
      localStorage.setItem("google_search_radius", $(this).val());
    });
    if (
      localStorage.getItem("google_search_radius") === "" ||
      localStorage.getItem("google_search_radius") === null ||
      localStorage.getItem("google_search_radius") === undefined
    ) {
      localStorage.setItem("google_search_radius", search_radius.val());
    }
    // FILTER RANGE INDICATOR SCRIPT - END

    // Set query result limit if its not cached - START
    if (localStorage.getItem("limit_query_results") === null) {
      localStorage.setItem(
        "limit_query_results",
        $("#limit_location_results").val()
      );
    } else {
      $("#limit_location_results").val(
        localStorage.getItem("limit_query_results")
      );
    }
    // Set query result limit if its not cached - END

    // Change query result limit if changed - START
    $("#limit_location_results").on("change", function (e) {
      localStorage.setItem("limit_query_results", $(this).val());
    });
    // Change query result limit if changed - END

    // FILTERS RESET FILTER VALUES - START
    $("#reset-locator-filters-btn").on("click", function (e) {
      reset_filters();
    });
    // FILTERS RESET FILTER VALUES - END

    // FILTERS GRAB DATA PER CATEGORY - START
    $.each(filters, function (index, arr) {
      $("#" + index + " input").on("change", function (e) {
        filters = JSON.parse(localStorage.getItem("search_filters"));
        if (
          $(this).is(":checked") &&
          $.inArray($(this).val(), filters[index]) === -1
        ) {
          filters[index].push($(this).val());
        } else {
          if ($.inArray($(this).val(), filters[index]) >= 0) {
            filters[index].splice($.inArray($(this).val(), filters[index]), 1);
          }
        }
        localStorage.setItem("search_filters", JSON.stringify(filters));
        localStorage.setItem(
          "search_filter_count",
          search_filter_count(filters)
        );
      });
    });
    // FILTERS GRAB DATA PER CATEGORY - END

    // SEARCH FILTER PANEL SUBMIT HANDLER - START
    locator_results_form.on("submit", search_submit_handler);
    // HANDLER FILTER PANEL SUBMIT - END

    // HANDLE BACK TO SEACH RESULTS LINK - START
    $("#back-to-search-results").on("click", function (e) {
      deactivate_map_marker();
      navigate_to_frame(locator_results_frame);
    });
    // HANDLE BACK TO SEACH RESULTS LINK - END

    // LIST OF ONE PAGE LOAD TRIGGERS THAT NEED TO FIRE - START
    // SUBMIT FORM TO GET RESULTS
    locator_results_form.trigger("submit");
    // LIST OF ONE PAGE LOAD TRIGGERS THAT NEED TO FIRE - END

    // RENDER MAPS ON PAGES - START
    //initMap($block.find('.acf-map'));
    /*$('.acf-map').each(function(){
      initMap($(this));
    });*/
    // RENDER MAPS ON PAGES - END

    /**
     * navigate_to_frame
     *
     * @param frame
     */
    function navigate_to_frame(frame) {
      $(".frame.active").removeClass("active");
      frame.addClass("active");
    }

    function get_page_filters() {
      var filters = {};
      $("#filter-accordions .filter").each(function (i, el) {
        var filter_header = $(this).find(".filter-header");
        var key = filter_header.attr("data-target").replace("#", "");
        if (key !== "filter-radius") {
          filters[key] = [];
        }
      });
      return filters;
    }

    /**
     * reset_filters
     */
    function reset_filters() {
      var filters = get_page_filters();
      localStorage.setItem("search_filters", JSON.stringify(filters));
      localStorage.setItem("search_filter_count", "0");
      localStorage.setItem("google_search_radius", "10");
      updateFilterFields();
      locator_results_form.trigger("submit");
    }
  };

  /**
   * search_submit_handler
   *
   * @param e
   */
  function search_submit_handler(e) {
    e.preventDefault();

    var input = document.getElementById("locator-results-location");

    if (input.value === "" || input.value === null) {
      if (
        "formatted_address" in
        $.parseJSON(localStorage.getItem("google_result"))
      ) {
        input.value = $.parseJSON(localStorage.getItem("google_result"))[
          "formatted_address"
        ];
      }
    }

    if (
      input.value !==
      $.parseJSON(localStorage.getItem("google_result"))["formatted_address"]
    ) {
      var handleSuggestions = function (predictions, status) {
        /** ERROR HANDLING **/
        if (status != google.maps.places.PlacesServiceStatus.OK) {
          if (!predictions && status == "ZERO_RESULTS") {
            alert(
              "Sorry, that location has not been recognised, please try again. Please note that we can only search UK locations."
            );
          }

          return;
        }
        /** HANDLE PREDICTIONS **/
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode(
          { placeId: predictions[0].place_id },
          function (results, status) {
            localStorage.setItem("google_result", JSON.stringify(results[0]));
            do_form_submission();
          }
        );
      };
      var service = new google.maps.places.AutocompleteService();
      service.getPlacePredictions(
        { input: input.value, componentRestrictions: { country: ["GB", "IM", "GG", "JE"] } },
        handleSuggestions
      );
    } else {
      do_form_submission();
    }
  }

  function do_form_submission() {
    // Initialise variables
    var locator_results_found = $("#locator-results-frame-found"),
      search_counter = $("#search-count"),
      filter_data = {
        search_filters: $.parseJSON(localStorage.getItem("search_filters")),
        google_result: $.parseJSON(localStorage.getItem("google_result")),
        google_search_radius: localStorage.getItem("google_search_radius"),
      };

    // Show loader
    search_counter.html("Loading your results");
    locator_results_found.html(
      '<div class="m-preloader"><div class="m-loader"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div></div>'
    );

    $("#locator-results-location").val(
      filter_data.google_result.formatted_address
    );

    var limit_results = localStorage.getItem("limit_query_results");

    // Set base ajax data
    var data = {
      action: "get_search_results_html",
      filter_data: filter_data,
      results_limit: limit_results,
    };

    // Get panel 2 results data via ajax and place in results div
    jQuery.post(scripts_params.ajaxurl, data, function (response) {
      // Update search result listing
      locator_results_found.html(response);

      // Update the x results found counter.
      var loc_count = 0;
      $(".location-entry").each(function (index, element) {
        loc_count = loc_count + 1;
      });
      if (loc_count.toString() === "0") {
        search_counter.html(
          loc_count.toString() +
            " results found. Try searching in a larger area or removing filters."
        );
      } else {
        if (loc_count.toString() === "1") {
          search_counter.html(loc_count.toString() + " result found");
        } else {
          search_counter.html(loc_count.toString() + " results found");
        }
      }

      $(".acf-map").each(function () {
        updateMap($(this));
      });
    });
  }

  /**
   * updateFilterFields
   */
  function updateFilterFields() {
    var filters = JSON.parse(localStorage.getItem("search_filters")),
      global_range_checkbox = $("#range_global"),
      search_radius = $("#search_radius"),
      radius = localStorage.getItem("google_search_radius");
    if ($.isPlainObject(filters)) {
      $.each(filters, function (index, arr) {
        //FIRST UNCHECK EVERYTHING
        $("#" + index + " input").prop("checked", false);
        //THEN CHECK CHOSEN ONES
        $.each(arr, function (i, val) {
          $("#" + index + ' input[value="' + val + '"]').prop("checked", true);
        });
      });
    }
    if (
      radius !== "" &&
      radius !== "null" &&
      radius !== "undefined" &&
      radius !== null &&
      radius !== undefined
    ) {
      if (radius === "global") {
        global_range_checkbox.prop("checked", true).trigger("change");
      } else {
        search_radius.val(radius);
      }
    }
  }

  /**
   * search_filter_count
   *
   * @param filters
   * @returns {number}
   */
  function search_filter_count(filters) {
    var count = 0;
    $.each(filters, function (index, arr) {
      $.each(arr, function (index2, arr2) {
        count = count + 1;
      });
    });
    return count;
  }

  /**
   * Get new map markers
   */
  function get_new_map_markers() {
    var locations = [];
    $(".location-entry").each(function (index, element) {
      var lat = parseFloat($(element).data("lat"));
      var lng = parseFloat($(element).data("lng"));
      locations.push({ lat: lat, lng: lng });
    });
    return locations;
  }

  /**
   * Google Places Code
   *
   * @param element_id
   */
  function google_places_initialize(element_id) {
    var input = document.getElementById(element_id);
    var autocomplete = new google.maps.places.Autocomplete(input, {
      componentRestrictions: { country: ["GB", "IM", "GG", "JE"] },
    });
    autocomplete.addListener("place_changed", function () {
      var place = autocomplete.getPlace();
      localStorage.setItem("google_result", JSON.stringify(place));
    });
  }

  /**
   * initMap
   *
   * Updates google map with new markers.
   *
   * @param   jQuery $el The jQuery element.
   * @return  object The map instance.
   */
  function initMap($el) {
    var mapArgs = {
      zoom: $el.data("zoom") || 16,
      center: { lat: 51.5287718, lng: -0.2416804 },
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    };
    return new google.maps.Map($el[0], mapArgs);
  }

  /**
   * updateMap
   *
   * Updates google map with new markers.
   *
   * @param   jQuery $el The jQuery element.
   * @return  object The map instance.
   */
  function updateMap($el) {
    // Create gerenic map.
    var mapArgs = {
      zoom: $el.data("zoom") || 16,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    };
    var map = new google.maps.Map($el[0], mapArgs);

    // Reset and add result markers
    map.markers = [];
    var locations = get_new_map_markers();
    initMarkers(locations, map);

    // Center map based on markers.
    if (map.markers.length > 0) {
      centerMapAroundMarkers(map);
    }

    return map;
  }

  /**
   * initMarkers
   *
   * Creates a marker for the given jQuery element and map.
   *
   * @param   jQuery $el The jQuery element.
   * @param   object The map instance.
   * @return  object The marker instance.
   */
  function initMarkers(locations, map) {
    $.each(locations, function (index, latLng) {
      // Create marker instance.
      var marker = new google.maps.Marker({
        position: latLng,
        icon:
          "https://s3-eu-west-1.amazonaws.com/s3-bucket-recycleyourelectricals.org.uk/wp-content/uploads/2020/02/pin-grey.png?markerId=" +
          (index + 1),
        animation: google.maps.Animation.DROP,
        cursor: "pointer",
        map: map,
      });
      marker.addListener("animation_changed", function () {
        $('[src="' + this.icon + '"]').addClass(
          "marker markerId" + (index + 1)
        );
      });
      marker.addListener("mouseover", function (e) {
        var number = index + 1,
          element = $(".markerId" + number);
        update_map_marker_image(
          element,
          "https://s3-eu-west-1.amazonaws.com/s3-bucket-recycleyourelectricals.org.uk/wp-content/uploads/2020/02/pin-pink.png"
        );
        activate_location_entry(number);
      });
      marker.addListener("mouseout", function (e) {
        var number = index + 1,
          element = $(".markerId" + number);
        update_map_marker_image(
          element,
          "https://s3-eu-west-1.amazonaws.com/s3-bucket-recycleyourelectricals.org.uk/wp-content/uploads/2020/02/pin-grey.png"
        );
        deactivate_location_entry();
      });
      marker.addListener("click", function (e) {
        var number = index + 1;
        $(
          '.location-entry[data-result-number="' +
            number +
            '"] .location-entry-details'
        ).trigger("click");
      });

      // Append to reference for later use.
      map.markers.push(marker);
    });
  }

  /**
   * update_map_marker_image
   *
   * @param marker
   * @param image
   */
  function update_map_marker_image(marker, image) {
    if (!marker.hasClass("active")) {
      marker.attr("src", image);
    }
  }

  /**
   * activate_map_marker
   *
   * @param marker
   */
  function activate_map_marker(marker) {
    deactivate_map_marker();
    if (!marker.hasClass("active")) {
      marker
        .addClass("active")
        .attr(
          "src",
          "https://s3-eu-west-1.amazonaws.com/s3-bucket-recycleyourelectricals.org.uk/wp-content/uploads/2020/02/pin-pink.png"
        );
    }
  }

  /**
   * deactivate_map_marker
   */
  function deactivate_map_marker() {
    var activeMarker = $(".marker.active");
    if (activeMarker.length > 0) {
      activeMarker
        .removeClass("active")
        .attr(
          "src",
          "https://s3-eu-west-1.amazonaws.com/s3-bucket-recycleyourelectricals.org.uk/wp-content/uploads/2020/02/pin-grey.png"
        );
    }
  }

  /**
   * activate_location_entry
   *
   * @param number
   */
  function activate_location_entry(number) {
    deactivate_location_entry();
    var location_entry = $(
      '.location-entry[data-result-number="' + number + '"]'
    );
    if (!location_entry.hasClass("active")) {
      location_entry.addClass("active");
    }
  }

  /**
   * deactivate_location_entry
   */
  function deactivate_location_entry() {
    var location_entry = $(".location-entry.active");
    if (location_entry.length > 0) {
      location_entry.removeClass("active");
    }
  }

  /**
   * centerMapAroundMarkers
   *
   * Centers the map showing all markers in view.
   *
   * @param   object The map instance.
   * @return  void
   */
  function centerMapAroundMarkers(map) {
    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function (marker) {
      bounds.extend({
        lat: marker.position.lat(),
        lng: marker.position.lng(),
      });
    });
    // Case: Single marker.
    if (map.markers.length === 1) {
      map.setCenter(bounds.getCenter());
      // Case: Multiple markers.
    } else {
      map.fitBounds(bounds);
    }
  }

  // Initialize each block on page load (front end).
  $(".lab-locator").each(function () {
    initializeBlock($(this));
  });

  // Initialize dynamic block preview (editor).
  if (window.acf) {
    window.acf.addAction(
      "render_block_preview/type=lab_locator",
      initializeBlock
    );
  }
})(jQuery);

(function ($) {
  /**
   * LAB - Small Locator Block
   *
   * Adds custom JavaScript to the block HTML.
   *
   * @date    04/02/2020
   * @since   1.0.0
   *
   * @param   object $block The block jQuery element.
   * @param   object attributes The block attributes (only available when editing).
   * @return  void
   */
  var initializeBlock = function ($block) {
    google.maps.event.addDomListener(window, "load", google_places_initialize);
    initMap($block.find(".acf-map-small"));

    $("#small-locator-search-form").on("submit", function (e) {
      e.preventDefault();
      var input = document.getElementById("small-locator-search-input");
      var service = new google.maps.places.AutocompleteService();
      var locatorUrl =
        $("#small-locator-search-form").attr("action") +
        "?rye-postcode=" +
        input.value;
      
      const navigateToLocator = () => {
        const postcode = input.value;
        const url = $("#small-locator-search-form").attr("action") +
        "?rye-postcode=" + postcode;

        return window.location.href = url;
      }

      var handleSuggestions = function (predictions, status) {
        /** ERROR HANDLING **/
        if (status != google.maps.places.PlacesServiceStatus.OK) {
          if (!predictions && status == "ZERO_RESULTS") {
            alert(
              "Sorry, that location has not been recognised, please try again. Please note that we can only search UK locations."
            );
          }

          return;
        }
        /** HANDLE PREDICTIONS **/
        var geocoder = new google.maps.Geocoder();

        if (geocoder) {
          geocoder.geocode(
            { placeId: predictions[0].place_id },
            function (results, status) {
              localStorage.setItem("google_result", JSON.stringify(results[0]));
              input.value = results[0].formatted_address;
              navigateToLocator();
            }
          );
        } else {
          navigateToLocator();
        }
      };
      try {
        service.getPlacePredictions(
          { input: input.value, componentRestrictions: { country: ["GB", "IM", "GG", "JE"] } },
          handleSuggestions
        );
      } catch (err) {
        console.log(err.message);
      }
    });
  };

  function google_places_initialize() {
    var input = document.getElementById("small-locator-search-input");
    var autocomplete = new google.maps.places.Autocomplete(input, {
      componentRestrictions: { country: ["GB", "IM", "GG", "JE"] },
    });
    autocomplete.addListener("place_changed", function () {
      var place = autocomplete.getPlace();
      localStorage.setItem("google_result", JSON.stringify(place));
    });
  }

  /**
   * initMap
   *
   * Renders a Google Map onto the selected jQuery element
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @return  object The map instance.
   */
  function initMap($el) {
    // Find marker elements within map.
    var $markers = $el.find(".marker");

    // Create gerenic map.
    var mapArgs = {
      zoom: $el.data("zoom") || 16,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    };
    var map = new google.maps.Map($el[0], mapArgs);

    // Add markers.
    map.markers = [];
    $markers.each(function () {
      initMarker($(this), map);
    });

    // Center map based on markers.
    centerMap(map);

    // Return map instance.
    return map;
  }

  /**
   * initMarker
   *
   * Creates a marker for the given jQuery element and map.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @param   object The map instance.
   * @return  object The marker instance.
   */
  function initMarker($marker, map) {
    // Get position from marker.
    var lat = $marker.data("lat");
    var lng = $marker.data("lng");
    var latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng),
    };

    // Create marker instance.
    var marker = new google.maps.Marker({
      position: latLng,
      animation: google.maps.Animation.DROP,
      map: map,
    });

    // Append to reference for later use.
    map.markers.push(marker);

    // If marker contains HTML, add it to an infoWindow.
    if ($marker.html()) {
      // Create info window.
      var infowindow = new google.maps.InfoWindow({
        content: $marker.html(),
      });

      // Show info window when marker is clicked.
      google.maps.event.addListener(marker, "click", function () {
        infowindow.open(map, marker);
      });
    }
  }

  /**
   * centerMap
   *
   * Centers the map showing all markers in view.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   object The map instance.
   * @return  void
   */
  function centerMap(map) {
    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function (marker) {
      bounds.extend({
        lat: marker.position.lat(),
        lng: marker.position.lng(),
      });
    });

    // Case: Single marker.
    if (map.markers.length === 1) {
      map.setCenter(bounds.getCenter());

      // Case: Multiple markers.
    } else {
      map.fitBounds(bounds);
    }
  }

  // Initialize each block on page load (front end).
  $(".lab-locator-block").each(function () {
    initializeBlock($(this));
  });

  // Initialize dynamic block preview (editor).
  if (window.acf) {
    window.acf.addAction(
      "render_block_preview/type=lab_locator_block",
      initializeBlock
    );
  }
})(jQuery);

(function($){

  /**
   * LAB - Logo Slider
   *
   * Adds custom JavaScript to the block HTML.
   *
   * @date    23/01/2020
   * @since   1.0.0
   *
   * @param   object $block The block jQuery element.
   * @param   object attributes The block attributes (only available when editing).
   * @return  void
   */
  var initializeBlock = function( $block ) {

    var owl = $block.find('.owl-carousel');

    owl.owlCarousel({
      loop: true,
      responsiveClass: true,
      responsive:{
        0: {
          items: 2
        },
        576: {
          items: 3
        },
        768: {
          items: 4
        }
      }
    });
  };

  // Initialize each block on page load (front end).
  $(document).ready(function(){
      $('.lab_logo_slider').each(function () {
        initializeBlock($(this));
      });
  });

  // Initialize dynamic block preview (editor).
  if( window.acf ) {
    window.acf.addAction( 'render_block_preview/type=lab_logo_slider', initializeBlock );
  }

})(jQuery);

(function ($) {
  /**
   * LAB - Looker Studio Embed
   *
   * Adds custom JavaScript to the block HTML.
   *
   * @date    23/01/2020
   * @since   1.0.0
   *
   * @param   object $block The block jQuery element.
   * @param   object attributes The block attributes (only available when editing).
   * @return  void
   */
  var initializeBlock = function ($block) {
    const containers = $block.find(".looker-studio-embed");

    containers.each(function () {
      const iframe = $(this).find("iframe");
      const width = iframe.attr("width");
      const height = iframe.attr("height");
      const padding = (height / width) * 100;
      $(this).attr("style", `padding-bottom: ${padding}%`);
    });
  };

  // Initialize each block on page load (front end).
  $(document).ready(function () {
    $(".lab_looker_studio_embed").each(function () {
      initializeBlock($(this));
    });
  });

  // Initialize dynamic block preview (editor).
  if (window.acf) {
    window.acf.addAction(
      "render_block_preview/type=lab_looker_studio_embed",
      initializeBlock
    );
  }
})(jQuery);

(function ($) {
	/**
	 * LAB - Meet the Team
	 *
	 * Adds custom JavaScript to the block HTML.
	 *
	 * @date    23/01/2020
	 * @since   1.0.0
	 *
	 * @param   object $block The block jQuery element.
	 * @param   object attributes The block attributes (only available when editing).
	 * @return  void
	 */
	var initializeBlock = function ($block) {
		var carousel = $block.find(".team-members"),
			filters = $block.find(".filters a"),
			carousel_slide_limit_main =
				$(window).width() >= 1060
					? 4
					: $(window).width() >= 860
					? 3
					: $(window).width() >= 640
					? 2
					: 1;
		if (
			carousel.hasClass("owl-carousel") &&
			carousel.children().length >= carousel_slide_limit_main
		) {
			carousel = init_team_member_carousel(carousel);
		} else if (
			!carousel.hasClass("owl-carousel") &&
			carousel.children().length >= carousel_slide_limit_main
		) {
			carousel.addClass("owl-carousel");
			init_team_member_carousel(carousel);
		} else {
			carousel.removeClass("loading").siblings(".m-preloader").fadeOut(300);
		}
		if (filters.length > 0) {
			filters.on("click", function (e) {
				e.preventDefault();
				var filter = $(this),
					id = filter.attr("href");

				if (!filter.parent().hasClass("active")) {
					var element = $block.find(".team-members");
					element.addClass("loading").siblings(".m-preloader").fadeIn(300);
					$.ajax({
						url: scripts_params.ajaxurl,
						method: "POST",
						data: {
							id: id,
							action: "get_team_members",
						},
						dataType: "json",
					})
						.done(function (data) {
							if (data) {
								var carousel_slide_limit =
									$(window).width() >= 1060
										? 4
										: $(window).width() >= 860
										? 3
										: $(window).width() >= 640
										? 2
										: 1;
								$block.find(".filters .active").removeClass("active");
								$block
									.find(".filters [aria-selected='true']")
									.attr("aria-selected", "false");
								filter.parent().addClass("active");
								filter.attr("aria-selected", "true");
								carousel.trigger("destroy.owl.carousel");
								var html = "";
								var container = $block.find(".team-members");
								jQuery.each(data, function (key, val) {
									html += '<div class="team-member">';
									if (val.image) {
										html +=
											'<img src="' +
											val.image[0] +
											'" alt="' +
											val.title +
											'" loading="lazy"/>';
									} else {
										html += '<div class="team-member-placeholder-image"></div>';
									}
									html += '<div class="team-member-content">';
									html += "<h4>" + val.title + "</h4>";
									html += '<p class="a-p-large">' + val.sub + "</p>";
									html += "<p>" + val.description + "</p>";
									html += "</div>";
									html += "</div>";
								});
								container.empty().append(html);
								if (data.length < carousel_slide_limit) {
									if (container.hasClass("owl-carousel")) {
										container
											.removeClass("owl-carousel loading")
											.siblings(".m-preloader")
											.fadeOut(300);
									} else {
										container
											.removeClass("loading")
											.siblings(".m-preloader")
											.fadeOut(300);
									}
								} else {
									if (!container.hasClass("owl-carousel")) {
										container.addClass("owl-carousel");
									}
									carousel = init_team_member_carousel(container);
								}
							}
						})
						.fail(function (a, b, c) {
							/*console.log(c);*/
						});
				}
			});
		}
	};

	function init_team_member_carousel(carousel) {
		return carousel.owlCarousel({
			items: 4,
			slideBy: 1,
			margin: 30,
			loop: true,
			nav: true,
			navText: ["", ""],
			responsive: {
				0: {
					items: 1,
					nav: false,
				},
				460: {
					items: 1,
					nav: true,
				},
				640: {
					items: 2,
				},
				860: {
					items: 3,
				},
				1060: {
					items: 4,
				},
			},
			onInitialized: function () {
				carousel.removeClass("loading").siblings(".m-preloader").fadeOut(300);
			},
		});
	}

	// Initialize each block on page load (front end).
	$(".lab-meet-the-team").each(function () {
		initializeBlock($(this));
	});

	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction(
			"render_block_preview/type=lab_meet_the_team",
			initializeBlock
		);
	}
})(jQuery);

(function($){

    /**
     * LAB - Newsletter Bubble
     *
     * Adds custom JavaScript to the block HTML.
     *
     * @date    23/01/2020
     * @since   1.0.0
     *
     * @param   object $block The block jQuery element.
     * @param   object attributes The block attributes (only available when editing).
     * @return  void
     */
    var initializeBlock = function( $block ) {
        
    };

    // Initialize each block on page load (front end).
    $('.lab-solid-hero').each(function () {
        initializeBlock($(this));
    });

    // Initialize dynamic block preview (editor).
    if( window.acf ) {
        window.acf.addAction( 'render_block_preview/type=lab_newsletter_bubble', initializeBlock );
    }

})(jQuery);

(function ($) {
	/**
	 * LAB - Page Header
	 *
	 * Adds custom JavaScript to the block HTML.
	 *
	 * @date    04/02/2020
	 * @since   1.0.0
	 *
	 * @param   object $block The block jQuery element.
	 * @param   object attributes The block attributes (only available when editing).
	 * @return  void
	 */
	var initializeBlock = function ($block) {
		var desktopImageToPreload = $block.find("[data-desktop-preload]");
		var mobileImageToPreload = $block.find("[data-mobile-preload]");

		var image = new Image();

		if (jQuery(window).width() > 600) {
			image.src = desktopImageToPreload.data("desktop-preload");
		} else {
			image.src = mobileImageToPreload.data("mobile-preload");
		}

		image.onload = function () {
			showImage($block.find(".m-preloader"));
		};
		image.onerror = function () {
			showImage($block.find(".m-preloader"));
		};

		google.maps.event.addDomListener(window, "load", google_places_initialize);

		$("#locations_search_autocomplete_form").on("submit", function (e) {
			e.preventDefault();
			var input = document.getElementById("locations_search_autocomplete");
			var error = document.querySelector(".lab-page-header__locator-error");

			const isEmpty = (str) => {
				return !str.trim().length;
			};

			if (isEmpty(input.value)) {
				error.setAttribute("aria-hidden", "false");
				e.preventDefault();
				return;
			}

			var service = new google.maps.places.AutocompleteService();
			var locatorUrl =
				$("#locations_search_autocomplete_form").attr("action") +
				"?rye-postcode=" +
				input.value;

			error.setAttribute("aria-hidden", "true");

			const navigateToLocator = () => {
				const postcode = input.value;
				const url =
					$("#locations_search_autocomplete_form").attr("action") +
					"?rye-postcode=" +
					postcode;

				return (window.location.href = url);
			};

			var handleSuggestions = function (predictions, status) {
				/** ERROR HANDLING **/
				if (status != google.maps.places.PlacesServiceStatus.OK) {
					if (!predictions && status == "ZERO_RESULTS") {
						alert(
							"Sorry, that location has not been recognised, please try again. Please note that we can only search UK locations."
						);
					}

					return;
				}
				/** HANDLE PREDICTIONS **/
				var geocoder = new google.maps.Geocoder();

				if (geocoder) {
					geocoder.geocode(
						{ placeId: predictions[0].place_id },
						function (results, status) {
							localStorage.setItem("google_result", JSON.stringify(results[0]));
							input.value = results[0].formatted_address;
							navigateToLocator();
						}
					);
				} else {
					navigateToLocator();
				}
			};
			try {
				service.getPlacePredictions(
					{
						input: input.value,
						componentRestrictions: { country: ["GB", "IM", "GG", "JE"] },
					},
					handleSuggestions
				);
			} catch (err) {
				console.log(err.message);
			}
		});
	};

	function google_places_initialize() {
		var input = document.getElementById("locations_search_autocomplete");
		var autocomplete = new google.maps.places.Autocomplete(input, {
			componentRestrictions: { country: ["GB", "IM", "GG", "JE"] },
		});
		autocomplete.addListener("place_changed", function () {
			var place = autocomplete.getPlace();
			localStorage.setItem("google_result", JSON.stringify(place));
		});
	}

	function showImage(preloader) {
		var text = prepHeading();
		preloader.parent().addClass("preloaded");
		preloader.fadeOut(300, function () {
			setTimeout(function () {
				typeHeading(text.split(""));
			}, 500);
			$(this).remove();
		});
	}

	function prepHeading() {
		var heading = $(".lab-page-header h1"),
			headingText = heading.text();
		heading.text("");
		return headingText;
	}

	function typeHeading(text) {
		if (text.length > 0) {
			var heading = $(".lab-page-header h1");

			setTimeout(function () {
				heading.text(heading.text() + text[0]);
				text.shift();
				typeHeading(text);
			}, 50);
		}
	}

	// Initialize each block on page load (front end).
	$(".lab-page-header").each(function () {
		initializeBlock($(this));
	});

	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction(
			"render_block_preview/type=lab_page_header",
			initializeBlock
		);
	}
})(jQuery);

(function ($) {
	/**
	 * LAB - Page Header BG
	 *
	 * Adds custom JavaScript to the block HTML.
	 *
	 * @date    04/02/2020
	 * @since   1.0.0
	 *
	 * @param   object $block The block jQuery element.
	 * @param   object attributes The block attributes (only available when editing).
	 * @return  void
	 */
	var initializeBlock = function ($block) {
		google.maps.event.addDomListener(window, "load", google_places_initialize);
		$("#locations_search_autocomplete_form").on("submit", function (e) {
			e.preventDefault();
			var input = document.getElementById("locations_search_autocomplete");
			var error = document.querySelector(".lab-page-header__locator-error");

			const isEmpty = (str) => {
				return !str.trim().length;
			};

			if (isEmpty(input.value)) {
				error.setAttribute("aria-hidden", "false");
				e.preventDefault();
				return;
			}

			var service = new google.maps.places.AutocompleteService();
			var locatorUrl =
				$("#locations_search_autocomplete_form").attr("action") +
				"?rye-postcode=" +
				input.value;

			error.setAttribute("aria-hidden", "true");

			const navigateToLocator = () => {
				const postcode = input.value;
				const url =
					$("#locations_search_autocomplete_form").attr("action") +
					"?rye-postcode=" +
					postcode;

				return (window.location.href = url);
			};

			var handleSuggestions = function (predictions, status) {
				/** ERROR HANDLING **/
				if (status != google.maps.places.PlacesServiceStatus.OK) {
					if (!predictions && status == "ZERO_RESULTS") {
						alert(
							"Sorry, that location has not been recognised, please try again. Please note that we can only search UK locations."
						);
					}

					return;
				}
				/** HANDLE PREDICTIONS **/
				var geocoder = new google.maps.Geocoder();

				if (geocoder) {
					geocoder.geocode(
						{ placeId: predictions[0].place_id },
						function (results, status) {
							localStorage.setItem("google_result", JSON.stringify(results[0]));
							input.value = results[0].formatted_address;
							navigateToLocator();
						}
					);
				} else {
					navigateToLocator();
				}
			};
			try {
				service.getPlacePredictions(
					{
						input: input.value,
						componentRestrictions: { country: ["GB", "IM", "GG", "JE"] },
					},
					handleSuggestions
				);
			} catch (err) {
				console.log(err.message);
			}
		});
	};

	function google_places_initialize() {
		var input = document.getElementById("locations_search_autocomplete");
		var autocomplete = new google.maps.places.Autocomplete(input, {
			componentRestrictions: { country: ["GB", "IM", "GG", "JE"] },
		});
		autocomplete.addListener("place_changed", function () {
			var place = autocomplete.getPlace();
			localStorage.setItem("google_result", JSON.stringify(place));
		});
	}

	// Initialize each block on page load (front end).
	$(".lab-page-header-bg").each(function () {
		initializeBlock($(this));
	});

	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction(
			"render_block_preview/type=lab_page_header_bg",
			initializeBlock
		);
	}
})(jQuery);

(function ($) {
  /**
   * LAB - Page Header Three
   *
   * Adds custom JavaScript to the block HTML.
   *
   * @date    04/02/2020
   * @since   1.0.0
   *
   * @param   object $block The block jQuery element.
   * @param   object attributes The block attributes (only available when editing).
   * @return  void
   */
  var initializeBlock = function ($block) {
    /*var text = prepHeading();
        setTimeout(function(){
            typeHeading(text.split(''));
        }, 500);*/
    // polyfill_images($block);
  };

  // IE Object Fit Polyfill
  // function polyfill_images(container){
  //     var images = container.find('.polyfill-image');

  //     if(images.length > 0){
  //         objectFitImages(images);
  //     }
  // }

  /*function prepHeading(){
        var heading = $('.lab-page-header-three h1'),
            headingText = heading.text();
        heading.text('');
        return headingText;
    }

    function typeHeading(text){
        var heading = $('.lab-page-header-three h1');
        if(text.length > 0){
            if(!heading.hasClass('typing')){
                heading.addClass('typing');
            }

            setTimeout(function(){
                heading.text(heading.text() + text[0]);
                text.shift();
                typeHeading(text);
            }, 50);
        } else {
           heading.removeClass('typing').addClass('typed');
        }
    }*/

  // Initialize each block on page load (front end).
  $(".lab-page-header-three").each(function () {
    initializeBlock($(this));
  });

  // Initialize dynamic block preview (editor).
  if (window.acf) {
    window.acf.addAction(
      "render_block_preview/type=lab_page_header_three",
      initializeBlock
    );
  }
})(jQuery);

(function ($) {
	/**
	 * LAB - Partner Logos
	 *
	 * Adds custom JavaScript to the block HTML.
	 *
	 * @date    23/01/2020
	 * @since   1.0.0
	 *
	 * @param   object $block The block jQuery element.
	 * @param   object attributes The block attributes (only available when editing).
	 * @return  void
	 */
	var initializeBlock = function ($block) {
		var carousel = $block.find(".owl-carousel"),
			filters = $block.find(".filters a"),
			carousel_slide_limit_main =
				$(window).width() >= 860 ? 5 : $(window).width() >= 500 ? 3 : 2;

		if (
			carousel.length > 0 &&
			carousel.children().length >= carousel_slide_limit_main
		) {
			carousel = init_partner_carousel(carousel);
		} else {
			carousel
				.removeClass("partner-logos-carousel owl-carousel loading")
				.addClass("partner-logos-container")
				.siblings(".m-preloader")
				.fadeOut(300);
		}
		if (filters.length > 0) {
			filters.on("click", function (e) {
				e.preventDefault();
				var filter = $(this),
					target = filter.data("cat-target");

				if (!filter.parent().hasClass("active")) {
					var element =
						$block.find(".owl-carousel").length > 0
							? $block.find(".owl-carousel")
							: $block.find(".partner-logos-container");
					element.addClass("loading").siblings(".m-preloader").fadeIn(300);
					$.ajax({
						url: scripts_params.ajaxurl,
						method: "POST",
						data: {
							category: target,
							block_id: $block.data("block-id"),
							post_id: $block.data("post-id"),
							action: "get_partner_logos",
						},
						dataType: "json",
					})
						.done(function (data) {
							if (data) {
								var carousel_slide_limit =
									$(window).width() >= 860
										? 5
										: $(window).width() >= 500
										? 3
										: 2;
								$block.find(".filters .active").removeClass("active");
								$block
									.find(".filters [aria-selected='true']")
									.attr("aria-selected", "false");
								filter.parent().addClass("active");
								filter.attr("aria-selected", "true");
								carousel.trigger("destroy.owl.carousel");
								var html = "";
								var container =
									$block.find(".owl-carousel").length > 0
										? $block.find(".owl-carousel")
										: $block.find(".partner-logos-container");
								jQuery.each(data, function (key, val) {
									if (
										typeof val.link !== "undefined" &&
										typeof val.link !== "string"
									) {
										html +=
											'<a href="' +
											val.link.url +
											'" target="' +
											val.link.target +
											'" class="partner-logo"><img data-cat="' +
											target +
											'" src="' +
											val.image +
											'" title="' +
											val.title +
											'" alt="' +
											val.alt +
											'"/></a>';
									} else {
										html +=
											'<div class="partner-logo"><img loading="lazy" data-cat="' +
											target +
											'" loading="lazy" src="' +
											val.image +
											'" title="' +
											val.title +
											'" alt="' +
											val.alt +
											'"/></div>';
									}
								});
								container.empty().append(html);
								if (data.length < carousel_slide_limit) {
									if (container.hasClass("partner-logos-carousel")) {
										container
											.removeClass(
												"partner-logos-carousel owl-carousel loading"
											)
											.addClass("partner-logos-container")
											.siblings(".m-preloader")
											.fadeOut(300);
									} else {
										container
											.removeClass("loading")
											.siblings(".m-preloader")
											.fadeOut(300);
									}
								} else {
									if (container.hasClass("partner-logos-container")) {
										container
											.removeClass("partner-logos-container")
											.addClass("partner-logos-carousel owl-carousel");
									}
									carousel = init_partner_carousel(container);
								}
							}
						})
						.fail(function (a, b, c) {});
				}
			});
		}
	};

	function init_partner_carousel(carousel) {
		const isOffsetSlider = Boolean(carousel.data("offsetSlider"));

		return carousel.owlCarousel({
			items: 5,
			slideBy: 5,
			margin: 30,
			loop: true,
			nav: true,
			navText: ["", ""],
			responsive: {
				0: {
					items: 2,
					slideBy: isOffsetSlider ? 1 : 2,
					nav: false,
				},
				500: {
					items: isOffsetSlider ? 1 : 3,
					slideBy: 3,
					nav: true,
				},
				860: {
					items: isOffsetSlider ? 1 : 5,
					slideBy: 5,
					nav: true,
				},
			},
			onInitialized: function () {
				carousel.removeClass("loading").siblings(".m-preloader").fadeOut(300);
			},
		});
	}

	// Initialize each block on page load (front end).
	$(".lab-partner-logos").each(function () {
		initializeBlock($(this));
	});

	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction(
			"render_block_preview/type=lab_partner_logos",
			initializeBlock
		);
	}
})(jQuery);

(function ($) {
	/**
	 * LAB - Page Header 2
	 *
	 * Adds custom JavaScript to the block HTML.
	 *
	 * @date    04/02/2020
	 * @since   1.0.0
	 *
	 * @param   object $block The block jQuery element.
	 * @param   object attributes The block attributes (only available when editing).
	 * @return  void
	 */
	var initializeBlock = function ($block) {
		// polyfill_images($block);

		/*var text = prepHeading();
    setTimeout(function(){
      typeHeading(text.split(''));
    }, 500);*/

		google.maps.event.addDomListener(window, "load", google_places_initialize);

		$("#locations_search_autocomplete_form").on("submit", function (e) {
			e.preventDefault();
			var input = document.getElementById("locations_search_autocomplete");
			var error = document.querySelector(".lab-page-header-two__locator-error");

			const isEmpty = (str) => {
				return !str.trim().length;
			};

			if (isEmpty(input.value)) {
				error.setAttribute("aria-hidden", "false");
				e.preventDefault();
				return;
			}

			var service = new google.maps.places.AutocompleteService();
			var locatorUrl =
				$("#locations_search_autocomplete_form").attr("action") +
				"?rye-postcode=" +
				input.value;

			error.setAttribute("aria-hidden", "true");

			const navigateToLocator = () => {
				const postcode = input.value;
				const url =
					$("#locations_search_autocomplete_form").attr("action") +
					"?rye-postcode=" +
					postcode;

				return (window.location.href = url);
			};

			var handleSuggestions = function (predictions, status) {
				/** ERROR HANDLING **/
				if (status != google.maps.places.PlacesServiceStatus.OK) {
					if (!predictions && status == "ZERO_RESULTS") {
						alert(
							"Sorry, that location has not been recognised, please try again. Please note that we can only search UK locations."
						);
					}

					return;
				}
				/** HANDLE PREDICTIONS **/
				var geocoder = new google.maps.Geocoder();

				if (geocoder) {
					geocoder.geocode(
						{ placeId: predictions[0].place_id },
						function (results, status) {
							localStorage.setItem("google_result", JSON.stringify(results[0]));
							input.value = results[0].formatted_address;
							navigateToLocator();
						}
					);
				} else {
					navigateToLocator();
				}
			};
			try {
				service.getPlacePredictions(
					{
						input: input.value,
						componentRestrictions: { country: ["GB", "IM", "GG", "JE"] },
					},
					handleSuggestions
				);
			} catch (err) {
				console.log(err.message);
			}
		});
	};

	// IE Object Fit Polyfill
	// function polyfill_images(container){
	//   var images = container.find('.polyfill-image');

	//   if(images.length > 0){
	//     objectFitImages(images);
	//   }
	// }

	/*function prepHeading(){
    var heading = $('.lab_page_header_two h1'),
        headingText = heading.text();
    heading.text('');
    return headingText;
  }

  function typeHeading(text){
    var heading = $('.lab_page_header_two h1');
    if(text.length > 0){
      if(!heading.hasClass('typing')){
        heading.addClass('typing');
      }

      setTimeout(function(){
        heading.text(heading.text() + text[0]);
        text.shift();
        typeHeading(text);
      }, 50);
    } else {
      heading.removeClass('typing').addClass('typed');
    }
  }*/

	function google_places_initialize() {
		var input = document.getElementById("locations_search_autocomplete");
		var autocomplete = new google.maps.places.Autocomplete(input, {
			componentRestrictions: { country: ["GB", "IM", "GG", "JE"] },
		});
		autocomplete.addListener("place_changed", function () {
			var place = autocomplete.getPlace();
			localStorage.setItem("google_result", JSON.stringify(place));
		});
	}

	// Initialize each block on page load (front end).
	$(".lab-page-header-two").each(function () {
		initializeBlock($(this));
	});

	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction(
			"render_block_preview/type=lab_page_header_two",
			initializeBlock
		);
	}
})(jQuery);

(function ($) {
	/**
	 * LAB - Pledge
	 *
	 * Adds custom JavaScript to the block HTML.
	 *
	 * @date    23/01/2020
	 * @since   1.0.0
	 *
	 * @param   object $block The block jQuery element.
	 * @param   object attributes The block attributes (only available when editing).
	 * @return  void
	 */
	var initializeBlock = function ($block) {
		// const block = $block.find(".lab-pledge");
		const form = $block.find(".lab-pledge__information");
		const modal = $block.find(".lab-pledge__modal");
		const indicator = $block.find(".lab-pledge__indicator");
		const counter = $block.find(".lab-pledge__counter");
		const average = $block.find(".lab-pledge__average");
		const image = $block.find(".lab-pledge__modal--image");

		// Store data
		const cache = {
			count: 0,
			average: 0,
			image: null,
		};

		const endpoints = {
			get: "/wp-json/rye/v1/pledges/count",
			post: "/wp-json/rye/v1/pledges/increment",
		};

		// Udpate pledge data on form submit
		form.on("submit", function (e) {
			e.preventDefault();

			// show the form values
			const formData = new FormData(e.target);
			const values = [...formData.entries()];

			setPledgeCount();
			setPledgeModal(modal);
		});

		// Get pledge image to reset
		const getPledgeImage = () => {
			const gif = new Image();
			gif.src = image.attr("src");
			cache.image = gif;
		};

		// Set pledge image again for restart
		const setPledgeImage = (src = "") => {
			image.attr("src", src);
		};

		const setCounters = (count) => {
			cache.count = count;
			cache.average = count * 5;

			indicator.text(cache.count);
			counter.text(cache.count);
			average.text(cache.average);
		};

		// get pledge count on update
		const getPledgeCount = () => {
			jQuery.ajax({
				method: "GET",
				url: endpoints.get,
				dataType: "json",
				success: function (res) {
					const number = res.data.count;
					cache.count = number;

					setCounters(number);
				},
			});
		};

		// set pledge count on update
		const setPledgeCount = () => {
			jQuery.ajax({
				method: "POST",
				url: endpoints.post,
				dataType: "json",
				success: function (res) {
					const number = res.data.count;
					cache.count = number;

					setCounters(number);
				},
			});
		};

		// Set pledge modal
		const setPledgeModal = (modal) => {
			var modal_animation_time = 500;
			open_modal(modal);

			function modal_focus_trap(element) {
				if (!element) return;
			
				const focusableElements = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
				const firstFocusableElement = focusableElements[0];
				const lastFocusableElement = focusableElements[focusableElements.length - 1];
			
				element.addEventListener("keydown", function(e) {
					if (!e.shiftKey && e.key === "Tab") {
						if (document.activeElement === lastFocusableElement) {
							firstFocusableElement.focus();
							e.preventDefault();
						}
					} else if (e.shiftKey && e.key === "Tab") {
						if (document.activeElement === firstFocusableElement) {
							lastFocusableElement.focus();
							e.preventDefault();
						} 
					}
				});
			}

			function open_modal(modal) {
				modal
					.fadeIn(modal_animation_time)
					.attr("aria-hidden", "false");

				modal_focus_trap(modal[0]);
				$(".close-pledge").focus();

				modal
					.find(".close-pledge")
					.off()
					.on("click", function (e) {
						e.preventDefault();
						close_modal(modal);
					});	
			}

			function close_modal(modal) {
				modal
					.attr("aria-hidden", "true")
					.fadeOut(modal_animation_time);
			}
		};

		// Run init
		getPledgeCount();
		getPledgeImage();
	};

	// Initialize each block on page load (front end).
	$(".lab-pledge").each(function () {
		initializeBlock($(this));
	});

	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction(
			"render_block_preview/type=lab_pledge",
			initializeBlock
		);
	}
})(jQuery);

(function($){

  /**
   * LAB - Recycle Block
   *
   * Adds custom JavaScript to the block HTML.
   *
   * @date    23/01/2020
   * @since   1.0.0
   *
   * @param   object $block The block jQuery element.
   * @param   object attributes The block attributes (only available when editing).
   * @return  void
   */
  var initializeBlock = function( $block ) {



    jQuery('#check_possiblity').click(function() {


      var possibility = jQuery('#possibility').val();

      if (possibility.length === 0 ) {
       $('#possibility').addClass('error').focus();
       $('.error-message').show().html('Please fill in the search field');

      } else {
        $('#possibility').removeClass('error');
      $.ajax({
        url: scripts_params.ajaxurl,
        type: 'POST',
        data: {
          'possibility' : possibility,
          'action': 'recycle_possibility'
        },
        dataType: 'json',
        success: function (data) {
          if(data === true) {
            jQuery('.possibility-state').show().addClass('show');
            jQuery('.possibility-success').show();
            jQuery('.possibility-fail').hide();

          } else {
            jQuery('.possibility-state').show().addClass('show');
            jQuery('.possibility-success').hide();
            jQuery('.possibility-fail').show();
          }
        },
        error: function(){
          /*console.log('error');*/
        }
      });

      }

    });

  };


  // Initialize each block on page load (front end).
  $('.lab-recycle-block').each(function () {
    initializeBlock($(this));
  });

  $(document).ready(function(){
    $('.lab-recycle-block').addClass('show');
  });

  // Initialize dynamic block preview (editor).
  if( window.acf ) {
    window.acf.addAction( 'render_block_preview/type=lab-recycle-block', initializeBlock );
  }

})(jQuery);

(function($){

    /**
     * LAB - Solid Hero
     *
     * Adds custom JavaScript to the block HTML.
     *
     * @date    23/01/2020
     * @since   1.0.0
     *
     * @param   object $block The block jQuery element.
     * @param   object attributes The block attributes (only available when editing).
     * @return  void
     */
    var initializeBlock = function( $block ) {

        var text = prepHeading();
        setTimeout(function(){
            typeHeading(text.split(''));
        }, 500);

    };

    function prepHeading(){
        var heading = $('.lab-solid-hero h1'),
            headingText = heading.text();
        heading.text('');
        return headingText;
    }

    function typeHeading(text){
        var heading = $('.lab-solid-hero h1');
        if(text.length > 0){
            if(!heading.hasClass('typing')){
                heading.addClass('typing');
            }

            setTimeout(function(){
                heading.text(heading.text() + text[0]);
                text.shift();
                typeHeading(text);
            }, 50);
        } else {
            heading.removeClass('typing').addClass('typed');
        }
    }

    // Initialize each block on page load (front end).
    $('.lab-solid-hero').each(function () {
        initializeBlock($(this));
    });

    // Initialize dynamic block preview (editor).
    if( window.acf ) {
        window.acf.addAction( 'render_block_preview/type=lab_solid_hero', initializeBlock );
    }

})(jQuery);

(function($){

    /**
     * LAB - Three CTA
     *
     * Adds custom JavaScript to the block HTML.
     *
     * @date    23/01/2020
     * @since   1.0.0
     *
     * @param   object $block The block jQuery element.
     * @param   object attributes The block attributes (only available when editing).
     * @return  void
     */
    var initializeBlock = function( $block ) {

    };

    // Initialize each block on page load (front end).
    $('.lab-three-cta').each(function () {
        initializeBlock($(this));
    });

    // Initialize dynamic block preview (editor).
    if( window.acf ) {
        window.acf.addAction( 'render_block_preview/type=lab_three_cta', initializeBlock );
    }

})(jQuery);

(function($){

    /**
     * LAB - Timeline
     *
     * Adds custom JavaScript to the block HTML.
     *
     * @date    23/01/2020
     * @since   1.0.0
     *
     * @param   object $block The block jQuery element.
     * @param   object attributes The block attributes (only available when editing).
     * @return  void
     */
    var initializeBlock = function( $block ) {

    };

    // Initialize each block on page load (front end).
    $('.timeline').each(function () {
        initializeBlock($(this));
    });

    // Initialize dynamic block preview (editor).
    if( window.acf ) {
        window.acf.addAction( 'render_block_preview/type=timeline', initializeBlock );
    }

})(jQuery);

(function($){

    /**
     * LAB - Video
     *
     * Adds custom JavaScript to the block HTML.
     *
     * @date    04/02/2020
     * @since   1.0.0
     *
     * @param   object $block The block jQuery element.
     * @param   object attributes The block attributes (only available when editing).
     * @return  void
     */
    var initializeBlock = function( $block ) {
        var imageToPreload = $block.find('.lab-video-poster');
        if(imageToPreload.length > 0){
            var image = new Image();
            image.src = imageToPreload.attr('src');
            image.onload = function(){
                $block.addClass('preloaded').find('.m-preloader').fadeOut(300, function(){
                    $(this).remove();
                });
            };
        } else {
					$block.addClass('preloaded').find('.m-preloader').fadeOut(300, function(){
						$(this).remove();
					});
				}
        
        var player = $block.find('video'),
            poster = $block.find('.lab-hero-video-play');
        $block.find('.lab-hero-video-icon').off().on('click', function(e){
            e.preventDefault();
            poster.fadeOut(300);
            player[0].play();
        });
    };

    // Initialize each block on page load (front end).
    $('.lab_video').each(function () {
        initializeBlock($(this));
    });

    // Initialize dynamic block preview (editor).
    if( window.acf ) {
        window.acf.addAction( 'render_block_preview/type=lab_video', initializeBlock );
    }

})(jQuery);

(function($){

  /**
   * SMS Recycling Reminder Template.
   *
   * Adds custom JavaScript to the block HTML.
   *
   * @date    23/01/2020
   * @since   1.0.0
   *
   * @param   object $block The block jQuery element.
   * @param   object attributes The block attributes (only available when editing).
   * @return  void
   */
  var initializeBlock = function( $block ) {
		window.cfields = {
			"4": "recycling_day",
			"5": "recycling_frequency"
		};

		window._show_thank_you = function (id, message, trackcmp_url, email) {
			var form = document.getElementById('_form_' + id + '_'),
				thank_you = form.querySelector('._form-thank-you');
			form.querySelector('._form-content').style.display = 'none';
			thank_you.innerHTML = message;
			thank_you.style.display = 'block';
			const vgoAlias = typeof visitorGlobalObjectAlias === 'undefined' ? 'vgo' : visitorGlobalObjectAlias;
			var visitorObject = window[vgoAlias];
			if (email && typeof visitorObject !== 'undefined') {
				visitorObject('setEmail', email);
				visitorObject('update');
			} else if (typeof (trackcmp_url) != 'undefined' && trackcmp_url) {
				// Site tracking URL to use after inline form submission.
				_load_script(trackcmp_url);
			}
			if (typeof window._form_callback !== 'undefined') window._form_callback(id);
		};

		window._show_error = function (id, message, html) {
			var form = document.getElementById('_form_' + id + '_'),
				err = document.createElement('div'),
				button = form.querySelector('button'),
				old_error = form.querySelector('._form_error');
			if (old_error) old_error.parentNode.removeChild(old_error);
			err.innerHTML = message;
			err.className = '_error-inner _form_error _no_arrow';
			var wrapper = document.createElement('div');
			wrapper.className = '_form-inner';
			wrapper.appendChild(err);
			button.parentNode.insertBefore(wrapper, button);
			document.querySelector('[id^="_form"][id$="_submit"]').disabled = false;
			if (html) {
				var div = document.createElement('div');
				div.className = '_error-html';
				div.innerHTML = html;
				err.appendChild(div);
			}
		};

		window._load_script = function (url, callback) {
			var head = document.querySelector('head'),
				script = document.createElement('script'),
				r = false;
			script.type = 'text/javascript';
			script.charset = 'utf-8';
			script.src = url;
			if (callback) {
				script.onload = script.onreadystatechange = function () {
					if (!r && (!this.readyState || this.readyState == 'complete')) {
						r = true;
						callback();
					}
				};
			}
			head.appendChild(script);
		};

		if (window.location.search.search("excludeform") !== -1) return false;

		var getCookie = function (name) {
			var match = document.cookie.match(new RegExp('(^|; )' + name + '=([^;]+)'));
			return match ? match[2] : null;
		}

		var setCookie = function (name, value) {
			var now = new Date();
			var time = now.getTime();
			var expireTime = time + 1000 * 60 * 60 * 24 * 365;
			now.setTime(expireTime);
			document.cookie = name + '=' + value + '; expires=' + now + ';path=/';
		}

		var addEvent = function (element, event, func) {
			if (element.addEventListener) {
				element.addEventListener(event, func);
			} else {
				var oldFunc = element['on' + event];
				element['on' + event] = function () {
					oldFunc.apply(this, arguments);
					func.apply(this, arguments);
				};
			}
		}

		var _removed = false;
		var form_to_submit = document.getElementById('_form_3_');
		var allInputs = form_to_submit.querySelectorAll('input, select, textarea'),
			tooltips = [],
			submitted = false;
	
		var getUrlParam = function (name) {
			var regexStr = '[\?&]' + name + '=([^&#]*)';
			var results = new RegExp(regexStr, 'i').exec(window.location.href);
			return results != undefined ? decodeURIComponent(results[1]) : false;
		};
	
		for (var i = 0; i < allInputs.length; i++) {
			var regexStr = "field\\[(\\d+)\\]";
			var results = new RegExp(regexStr).exec(allInputs[i].name);
			if (results != undefined) {
				allInputs[i].dataset.name = window.cfields[results[1]];
			} else {
				allInputs[i].dataset.name = allInputs[i].name;
			}
			var fieldVal = getUrlParam(allInputs[i].dataset.name);
	
			if (fieldVal) {
				if (allInputs[i].dataset.autofill === "false") {
					continue;
				}
				if (allInputs[i].type == "radio" || allInputs[i].type == "checkbox") {
					if (allInputs[i].value == fieldVal) {
						allInputs[i].checked = true;
					}
				} else {
					allInputs[i].value = fieldVal;
				}
			}
		}
	
		var remove_tooltips = function () {
			for (var i = 0; i < tooltips.length; i++) {
				tooltips[i].tip.parentNode.removeChild(tooltips[i].tip);
			}
			tooltips = [];
		};

		var remove_tooltip = function (elem) {
			for (var i = 0; i < tooltips.length; i++) {
				if (tooltips[i].elem === elem) {
					tooltips[i].tip.parentNode.removeChild(tooltips[i].tip);
					tooltips.splice(i, 1);
					return;
				}
			}
		};

		var create_tooltip = function (elem, text) {
			var tooltip = document.createElement('div'),
				arrow = document.createElement('div'),
				inner = document.createElement('div'),
				new_tooltip = {};
			if (elem.type != 'radio' && elem.type != 'checkbox') {
				tooltip.className = '_error';
				arrow.className = '_error-arrow';
				inner.className = '_error-inner';
				inner.innerHTML = text;
				tooltip.appendChild(arrow);
				tooltip.appendChild(inner);
				elem.parentNode.appendChild(tooltip);
			} else {
				tooltip.className = '_error-inner _no_arrow';
				tooltip.innerHTML = text;
				elem.parentNode.insertBefore(tooltip, elem);
				new_tooltip.no_arrow = true;
			}
			new_tooltip.tip = tooltip;
			new_tooltip.elem = elem;
			tooltips.push(new_tooltip);
			return new_tooltip;
		};

		var resize_tooltip = function (tooltip) {
			var rect = tooltip.elem.getBoundingClientRect();
			var doc = document.documentElement,
				scrollPosition = rect.top - ((window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0));
			if (scrollPosition < 40) {
				tooltip.tip.className = tooltip.tip.className.replace(/ ?(_above|_below) ?/g, '') + ' _below';
			} else {
				tooltip.tip.className = tooltip.tip.className.replace(/ ?(_above|_below) ?/g, '') + ' _above';
			}
		};

		var resize_tooltips = function () {
			if (_removed) return;
			for (var i = 0; i < tooltips.length; i++) {
				if (!tooltips[i].no_arrow) resize_tooltip(tooltips[i]);
			}
		};

		var validate_field = function (elem, remove) {
			var tooltip = null,
				value = elem.value,
				no_error = true;
			remove ? remove_tooltip(elem) : false;
			if (elem.type != 'checkbox') elem.className = elem.className.replace(/ ?_has_error ?/g, '');
			if (elem.getAttribute('required') !== null) {
				if (elem.type == 'radio' || (elem.type == 'checkbox' && /any/.test(elem.className))) {
					var elems = form_to_submit.elements[elem.name];
					if (!(elems instanceof NodeList || elems instanceof HTMLCollection) || elems.length <= 1) {
						no_error = elem.checked;
					} else {
						no_error = false;
						for (var i = 0; i < elems.length; i++) {
							if (elems[i].checked) no_error = true;
						}
					}
					if (!no_error) {
						tooltip = create_tooltip(elem, "Please select an option.");
					}
				} else if (elem.type == 'checkbox') {
					var elems = form_to_submit.elements[elem.name],
						found = false,
						err = [];
					no_error = true;
					for (var i = 0; i < elems.length; i++) {
						if (elems[i].getAttribute('required') === null) continue;
						if (!found && elems[i] !== elem) return true;
						found = true;
						elems[i].className = elems[i].className.replace(/ ?_has_error ?/g, '');
						if (!elems[i].checked) {
							no_error = false;
							elems[i].className = elems[i].className + ' _has_error';
							err.push("Checking %s is required".replace("%s", elems[i].value));
						}
					}
					if (!no_error) {
						tooltip = create_tooltip(elem, err.join('<br/>'));
					}
				} else if (elem.tagName == 'SELECT') {
					var selected = true;
					if (elem.multiple) {
						selected = false;
						for (var i = 0; i < elem.options.length; i++) {
							if (elem.options[i].selected) {
								selected = true;
								break;
							}
						}
					} else {
						for (var i = 0; i < elem.options.length; i++) {
							if (elem.options[i].selected && !elem.options[i].value) {
								selected = false;
							}
						}
					}
					if (!selected) {
						elem.className = elem.className + ' _has_error';
						no_error = false;
						tooltip = create_tooltip(elem, "Please select an option.");
					}
				} else if (value === undefined || value === null || value === '') {
					elem.className = elem.className + ' _has_error';
					no_error = false;
					tooltip = create_tooltip(elem, "This field is required.");
				}
			}
			if (no_error && elem.name == 'email') {
				if (!value.match(/^[\+_a-z0-9-'&=]+(\.[\+_a-z0-9-']+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/i)) {
					elem.className = elem.className + ' _has_error';
					no_error = false;
					tooltip = create_tooltip(elem, "Enter a valid email address.");
				}
			}
			if (no_error && /date_field/.test(elem.className)) {
				if (!value.match(/^\d\d\d\d-\d\d-\d\d$/)) {
					elem.className = elem.className + ' _has_error';
					no_error = false;
					tooltip = create_tooltip(elem, "Enter a valid date.");
				}
			}
			tooltip ? resize_tooltip(tooltip) : false;
			return no_error;
		};

		var needs_validate = function (el) {
			if (el.getAttribute('required') !== null) {
				return true
			}
			if (el.name === 'email' && el.value !== "") {
				return true
			}
			return false
		};

		var validate_form = function (e) {
			var err = form_to_submit.querySelector('._form_error'),
				no_error = true;
			if (!submitted) {
				submitted = true;
				for (var i = 0, len = allInputs.length; i < len; i++) {
					var input = allInputs[i];
					if (needs_validate(input)) {
						if (input.type == 'text') {
							addEvent(input, 'blur', function () {
								this.value = this.value.trim();
								validate_field(this, true);
							});
							addEvent(input, 'input', function () {
								validate_field(this, true);
							});
						} else if (input.type == 'radio' || input.type == 'checkbox') {
							(function (el) {
								var radios = form_to_submit.elements[el.name];
								for (var i = 0; i < radios.length; i++) {
									addEvent(radios[i], 'click', function () {
										validate_field(el, true);
									});
								}
							})(input);
						} else if (input.tagName == 'SELECT') {
							addEvent(input, 'change', function () {
								validate_field(this, true);
							});
						} else if (input.type == 'textarea') {
							addEvent(input, 'input', function () {
								validate_field(this, true);
							});
						}
					}
				}
			}

			remove_tooltips();

			for (var i = 0, len = allInputs.length; i < len; i++) {
				var elem = allInputs[i];
				if (needs_validate(elem)) {
					if (elem.tagName.toLowerCase() !== "select") {
						elem.value = elem.value.trim();
					}
					validate_field(elem) ? true : no_error = false;
				}
			}

			if (!no_error && e) {
				e.preventDefault();
			}

			resize_tooltips();

			return no_error;
		};

		addEvent(window, 'resize', resize_tooltips);
		addEvent(window, 'scroll', resize_tooltips);

		window._old_serialize = null;

		if (typeof serialize !== 'undefined') window._old_serialize = window.serialize;

		_load_script("//d3rxaij56vjege.cloudfront.net/form-serialize/0.3/serialize.min.js", function () {
			window._form_serialize = window.serialize;
			if (window._old_serialize) window.serialize = window._old_serialize;
		});

		var form_submit = function (e) {
			e.preventDefault();
			if (validate_form()) {
				// use this trick to get the submit button & disable it using plain javascript
				document.querySelector('#_form_3_submit').disabled = true;
				var serialized = _form_serialize(document.getElementById('_form_3_')).replace(/%0A/g, '\\n');
				var err = form_to_submit.querySelector('._form_error');
				err ? err.parentNode.removeChild(err) : false;
				_load_script('https://materialchange.activehosted.com/proc.php?' + serialized + '&jsonp=true');
			}
			return false;
		};
		
		addEvent(form_to_submit, 'submit', form_submit);
  };

  // Initialize each block on page load (front end).
  $('.sms_recycling_reminder').each(function () {
    initializeBlock($(this));
  });

  // Initialize dynamic block preview (editor).
  if( window.acf ) {
    window.acf.addAction( 'render_block_preview/type=sms_recycling_reminder', initializeBlock );
  }

})(jQuery);
